<div *ngIf="phoneApp" xmlns="http://www.w3.org/1999/html">
  <div class="daPic">
    <div style="text-align: center">
      <div class="titleFont" *ngIf="myUser.role=='LINEOP' && screenMode=='E'" style="padding-top: 30%; color:white;font-size: 30px; padding-left: 0">Container Charges Entry </div>
      <div class="titleFont" *ngIf="myUser.role=='LINEOP' && screenMode=='I'" style="padding-top: 30%; color:white;font-size: 30px; padding-left: 0">Container Charges Inquiry </div>
      <div class="titleFont" *ngIf="myUser.role=='LINEOP' && screenMode=='V'" style="padding-top: 30%; color:white;font-size: 30px; padding-left: 0">Container Void </div>
      <div class="titleFont" *ngIf="myUser.role!='LINEOP' && screenMode=='E'" style="padding-top: 30%; color:white;font-size: 30px; padding-left: 0">Container Charges Entry </div>
      <div class="titleFont" *ngIf="myUser.role!='LINEOP' && screenMode=='I'" style="padding-top: 30%; color:white;font-size: 30px; padding-left: 0">Container Charges Inquiry </div>
      <div class="titleFont" *ngIf="myUser.role!='LINEOP' && screenMode=='V'" style="padding-top: 30%; color:white;font-size: 30px; padding-left: 0">Container Void </div>
    </div>



    <table style="width: 100%; height: 100%; padding-top: 1%; margin: 0px">
      <tr>
        <td  >
          <table  class="table-fill" style="height: 100%; text-align: center">
            <tr>
              <td style="vertical-align: top;">
                <div>
                  <mat-card class="speech-bubble3" style="text-align: center;background-color: rgba(238,238,237,1); " xmlns="http://www.w3.org/1999/html">
                    <div style="padding-top: 5px" *ngIf="!inquiryOnly">
                      <mat-button-toggle-group [(ngModel)]="screenMode" (click)="setCheckedField()">
                        <mat-button-toggle checked class="beigeButton"  value="E">entry</mat-button-toggle>
                        <mat-button-toggle class="beigeButton"  value="I" >inquiry</mat-button-toggle>
                        <mat-button-toggle class="beigeButton" value="V">void</mat-button-toggle>
                      </mat-button-toggle-group>
                    </div>
                    <mat-form-field  class="newField" style=" font-size: 17px; min-width: 90%; max-width: 90%; padding: 10px" appearance="outline" floatLabel="always">
                      <mat-label style="font-size: 20px; color: #E61E00">Container</mat-label>
                      <input  [(ngModel)]="txtFromArea"  matInput cdkTextareaAutosize oninput="this.value = this.value.toUpperCase()">
                      <mat-icon (click)="getSearchItems()" matSuffix style="position:relative; top: -9px"><img style="vertical-align: center;" src="assets/search.svg" ></mat-icon>
                    </mat-form-field>
                    <div style="padding-top: 10px" *ngIf="screenMode=='E' &&  (myUser.role=='LINEOP' || myUser.credit_status=='OAC')">
                      <mat-radio-group [(ngModel)]="payType" (click)="resetScreen()">
                        <mat-radio-button class="smallerFont" style="font-weight: bolder" value="C" >Credit Card</mat-radio-button>
                        <span style="padding-left: 5px"></span>
                        <mat-radio-button class="smallerFont"  style="font-weight: bolder"  value="G" >Guarantee</mat-radio-button>
                      </mat-radio-group>
                    </div>
                    <div style="padding-bottom: 15px; padding-top: 5px; text-align: center">
                      <div class="errorDiv2" *ngIf="submitted && didntEnterShit">Must Have 1 Container</div>
                      <div class="errorDiv2" *ngIf="submitted && badContainer">No Container Found or Unauthorized to view</div>
                      <div class="errorDiv2" style="text-align: center" *ngIf="submitted && noPayType">Must Choose Payment Type</div>
                      <div class="errorDiv2" *ngIf="submitted  && maherError!=null">{{maherError}}</div>
                      <div class="errorDiv2" *ngIf="insertNoConts">Must Have At Least 1 Container For Insert</div>
                    </div>

                  </mat-card>
                </div>




                <div *ngIf="showPhoneDetailScreen">
                  <span *ngFor="let xx of contView.charges" >
                        <div style="padding-top: 8%">
                          <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">

                            <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                              <div *ngIf="payType=='G'" class="guarantee"></div>
                              <div *ngIf="payType=='C'" class="payment"></div>
                            </div>
                            <div style="text-align: -webkit-center">
                              <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px"> {{xx.typeDescription}} Charge</div>
                            </div>

                            <div *ngIf="xx.type=='STORAGE' || xx.type=='REEFER' ">
                                  <mat-form-field class="newField" appearance="outline"  style="min-width: 95%" floatLabel="always" >
                                    <mat-label style="font-size: 20px; color: #E61E00" >FreeTime Date</mat-label>
                                    <input [(ngModel)]="xx.fte_date_fmt" oninput="this.value = this.value.toUpperCase()" matInput readonly/>
                                  </mat-form-field>
                              </div>

                               <div *ngIf="xx.type=='STORAGE' || xx.type=='REEFER' " floatLabel="always">
                                  <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                                    <mat-label style="font-size: 20px; color: #E61E00">Demurrage Days</mat-label>
                                    <input [(ngModel)]="xx.days" matInput readonly/>
                                  </mat-form-field>
                               </div>
                              <mat-form-field class="newField" appearance="outline"  style="min-width: 95%" floatLabel="always">
                                <mat-label style="font-size: 20px; color: #E61E00" *ngIf="xx.flatRate!='Y'">Amount</mat-label>
                                <mat-label style="min-width:fit-content; color: #E61E00;"  *ngIf="xx.flatRate=='Y'">Flat Rate Applied </mat-label>
                                <input [(ngModel)]="xx.amout" matInput readonly/>
                              </mat-form-field>
                             <div [hidden]="xx.type!=null && (xx.type.toUpperCase().includes('EXAM') && !xx.type.toUpperCase().includes('REDELIVER')) || xx.flatRate=='Y'">

                              <ng-container *ngIf="xx.rangeMode">
                              <mat-form-field class="newField" appearance="outline" style="min-width: 95%" floatLabel="always" >
                                  <mat-label style="font-size: 20px; color: #E61E00" >Payment Date</mat-label>
                                  <mat-date-range-input style="vertical-align: center;  min-height: 26px; max-width: 100%; margin-top: 10px;  "
                                    [min]="xx.start_datefmt"
                                    [max]="contView.end_datefmt"
                                    [dateFilter]="dateFilter"
                                    [rangePicker]="picker"
                                    (click)="setupRow(xx,xx.type,xx.start_datefmt)"
                                    (dateChange)="emitDatesCharges($event,xx,selection2.isSelected(xx))"
                                      >
                                    <input matStartDate matInput style="margin-top: 0"  [(ngModel)]="xx.start_date_in">
                                    <input matEndDate   matInput [(ngModel)]="xx.end_date_in"   >
                                  </mat-date-range-input>
                                  <mat-date-range-picker   [startAt]="xx.start_datefmt"  style="display: inline-flex;"  (opened)="onOpen()" [dateClass]="dateClass()" (mousedown)="setupRow(xx,xx.type,xx.start_datefmt)" #picker ></mat-date-range-picker>
                                  <mat-datepicker-toggle   (mousedown)="setupRow(xx,xx.type,xx.start_datefmt)" matSuffix [for]="picker"></mat-datepicker-toggle>
                              </mat-form-field>
                              </ng-container>

                               <ng-container *ngIf="!xx.rangeMode">
                                   <mat-form-field class="newField" appearance="outline" style="min-width: 95%" floatLabel="always" >
                                  <mat-label style="font-size: 20px; color: #E61E00" >Payment Date</mat-label>
                                    <input    matInput
                                              [min]="xx.start_datefmt"
                                              [max]="contView.end_datefmt"
                                              [dateFilter]="dateFilter"
                                              [matDatepicker]="picker"
                                              (click)="setupRow(xx,xx.type,xx.start_datefmt)"
                                              (dateChange)="emitDatesCharges($event,xx,selection2.isSelected(xx))"
                                              [(ngModel)]="xx.start_date_in"
                                    >
                                  <mat-datepicker   [startAt]="xx.start_datefmt"  style="display: inline-flex;"  (opened)="onOpen()" [dateClass]="dateClass()"  #picker></mat-datepicker>
                                  <mat-datepicker-toggle (mousedown)="setupRow(xx,xx.type,xx.start_datefmt)" matSuffix [for]="picker"></mat-datepicker-toggle>
                                 </mat-form-field>
                                </ng-container>

                                  <div style="display: none">
                                    <div class="datepicker-footer" #datepickerFooter>

                                      <table style="width: 100%; height:100%; border-top: #E61E00 solid 2px">
                                        <tr >
                                          <td colspan="4" class="smallerFont" style="font-weight: bolder; color: #E61E00">legend</td>
                                        </tr>
                                        <tr>
                                          <td style="width: 5%">
                                            <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/guarantee.png" >
                                          </td>
                                          <td style="width: 30%">
                                            <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Guarantee</p>
                                          </td>
                                          <td style="width: 5%">
                                            <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/payment-24px.svg" >
                                          </td>
                                          <td style="width: 30%">
                                            <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Credit Card</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width: 5%">
                                            <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/cash.png" >
                                          </td>
                                          <td style="width: 30%">
                                            <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Prepaid</p>
                                          </td>
                                          <td style="width: 5%">
                                            <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/waiver.jpg" >
                                          </td>
                                          <td style="width: 30%">
                                            <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Waived</p>
                                          </td>
                                        </tr>
                                      </table>

                                    </div>
                                  </div>
                             </div>

                            <mat-form-field class="newField" appearance="outline"  style="min-width: 95%" floatLabel="always">
                                <mat-label style="font-size: 20px; color: #E61E00">Reference Number</mat-label>
                                <input [(ngModel)]="xx.reference_number" matInput/>
                            </mat-form-field>

                            <mat-form-field class="newField" appearance="outline"  style="min-width: 95%" floatLabel="always">
                                <mat-label style="font-size: 20px; color: #E61E00">Remarks</mat-label>
                                <input [(ngModel)]="xx.remarks" matInput />
                            </mat-form-field>


                          </mat-card>
                        </div>


                  </span>

                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                    <div style="text-align: center; padding-top: 3%; padding-bottom: 2%">
                      <div class="errorDiv2 flash" *ngIf="nothingSelected && submitted">Must Fill Out At Least One Record</div>
                      <div class="errorDiv2 flash" *ngIf="missingDate && submitted">Date Missing For {{typeOut}} Charge</div>
                      <div class="errorDiv2 flash" *ngIf="missingRef && submitted">Reference Number Missing For {{typeOut}} Charge</div>
                      <div class="errorDiv2 flash" *ngIf="badChars && submitted">Invalid Character in Reference Number  For {{typeOut}} Charge</div>
                      <div class="errorDiv2 flash" *ngIf="badRemarks && submitted">Invalid Character in Remarks  For {{typeOut}} Charge</div>
                      <div class="errorDiv2 flash" *ngIf="missingBoth && submitted">Date and Reference Number Missing For {{typeOut}} Charge</div>
                      <div class="errorDiv2 flash" *ngIf="maherError && submitted">{{maherError}}</div>
                      <button mat-button  (click)="verifySelectionPhone()" class="blueButton" style="margin: 9px" >Proceed To Checkout</button>
                    </div>
                    </mat-card>
                  </div>
                </div>




                <div *ngIf="showSummaryScreen">
                <table style="width: 100%; height: max-content; padding-bottom: 25px; padding-top: 10px">
                  <tr>
                    <td style="width: 75%; height: 100%; text-align: -webkit-center">
                      <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);left: 0%; min-width: 97%; max-width: 97%; " xmlns="http://www.w3.org/1999/html">
                        <div style="background-color: black; padding: 5px">
                          <div class="titleFont"  style="padding-bottom: 10px; padding-top: 10px; text-align: center; color: white">Step 1: Review Order Summary</div>
                        </div>
                        <div class="scrollable" style="padding-top: 5px; border-bottom: solid">
                    <span *ngFor="let charges of contGuarArrayDisp;" >
                    <table style="width: 100%; height: min-content; vertical-align: top; ">
                      <tr>
                        <td  *ngIf="charges.container!=' '" style="text-align: center; width: 100%;" colspan="3">
                        </td>
                      </tr>

                      <tr>
                        <td style="text-align: center; width: 100%;" colspan="3">
                          <div class="titleFont" style="font-size: 27px; padding-top: 5px;text-decoration: underline; font-family: inherit" *ngIf="charges.container!=' '">{{charges.container}}</div>
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 10%">
                          <img style="height: 40px; width: 40px; padding-right: 10px; " *ngIf="charges.chargeEvent.toUpperCase()=='DEMURRAGE'" src="assets/cargo_container.png" >
                          <img style="height: 40px; width: 40px; padding-right: 10px; " *ngIf="charges.chargeEvent.toUpperCase()=='POWER'" src="assets/cold.png" >
                          <img style="height: 40px; width: 40px; padding-right: 10px;" *ngIf="charges.chargeEvent.toUpperCase().includes('SHIPSIDE')"  src="assets/vessel.png" >
                          <img style="height: 40px; width: 40px; padding-right: 10px;" *ngIf="charges.chargeEvent.toUpperCase().includes('COAST GUARD')"  src="assets/coast-guard.png" >
                          <img style="height: 40px; width: 40px; padding-right: 10px;" *ngIf="charges.chargeEvent.toUpperCase().includes('OFF')"  src="assets/offsite-icon.png" >
                          <img style="height: 40px; width: 40px; padding-right: 10px;" *ngIf="charges.chargeEvent.toUpperCase().includes('REDELIVERY')"  src="assets/export-redeliver.png" >


                        </td>
                        <td style="width: 70%; text-align: start">
                          <div class="titleFont" >{{charges.chargeEvent}}</div>
                        </td>
                        <td style="width: 20%; text-align: right; padding-right: 5px">
                          <div class="titleFont" *ngIf="payType=='C'" >{{charges.totalAmountWithFee}}</div>
                          <div class="titleFont" *ngIf="payType!='C'" >{{charges.totalAmount}}</div>
                        </td>
                      </tr>
                      <tr>

                        <td style="width: 10%">
                        </td>
                        <td style="width: 70%; text-align: start">
                          <span *ngFor="let children of charges.chargeDates" >
                            <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: -13px" *ngIf="charges.chargeEvent!=null && (!charges.chargeEvent.toUpperCase().includes('EXAM') || charges.chargeEvent.toUpperCase().includes('REDELIVERY'))">{{children.description}}</div>
                          </span>
                          <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: -3px" *ngIf="charges.chargeEvent!=null && charges.chargeEvent.toUpperCase().includes('EXAM') && !charges.chargeEvent.toUpperCase().includes('REDELIVERY')">Exam Fee</div>
                          <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: -3px" *ngIf="charges.flatRate=='Y'">Flat Rate</div>
                          <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: -3px" *ngIf="payType=='C'">Credit Card Fee</div>
                        </td>
                        <td style="width: 20%; text-align: right; padding-right: 5px">
                          <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: -3px">{{charges.totalAmount}}</div>
                          <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: -3px" *ngIf="payType=='C'">{{charges.totalFees}}</div>
                        </td>
                      </tr>

                      <tr>
                        <td  style="text-align: center; width: 100%; padding-bottom: 10px" colspan="3">
                        </td>
                      </tr>
                    </table>

                    </span>
                        </div>
                        <div style="height: 15.6%">
                          <table style="width: 100%; height: 100%; background-color: lightgrey;">
                            <tr>
                              <td style="width: 10%">
                              </td>
                              <td style="width: 70%; text-align: right; vertical-align:bottom; padding-right: 15px">
                                <div class="titleFont" *ngIf="payType=='C'">Subtotal: </div>
                                <div class="titleFont" *ngIf="payType=='C' && !ipadView">C.C. Processing Fee: </div>
                                <div class="titleFont" *ngIf="payType=='C' && ipadView">C.C. Fee: </div>
                                <div class="titleFont" >Grand Total:</div>
                              </td>
                              <td style="width: 20%; text-align: right; vertical-align: bottom; padding-right: 17px">
                                <div class="titleFont" *ngIf="payType=='C'">{{subTotalDisp}} </div>
                                <div class="titleFont" *ngIf="payType=='C'">{{totalFeesDisp}} </div>
                                <div class="titleFont" *ngIf="payType=='C'" >{{grandTotalWFeeDisp}}</div>
                                <div class="titleFont" *ngIf="payType!='C'" >{{grandTotalDisp}}</div>
                              </td>
                            </tr>
                          </table>
                        </div>

                      </mat-card>
                      <div style="padding-top: 25px"></div>


                      <mat-card class="iso-bubble" style="text-align: -webkit-center;text-align: -moz-center;background-color: rgba(238,238,237,0.7);left: 0%; min-width: 97%; max-width: 97%; padding-bottom: 15px " xmlns="http://www.w3.org/1999/html">

                      <div style="background-color: black; padding: 5px; max-width: 100%">
                        <div class="titleFont" style="padding-bottom: 10px; padding-top: 10px; text-align: center; color: white">Step 2: Billing Information </div>
                      </div>

                      <form #billForm  [formGroup]="myForm"  autocomplete="off" style="text-align: -webkit-center;text-align: -moz-center;"   novalidate>


                        <div style="vertical-align: top;background-color: rgba(238,238,237,0.7); height: 100%; max-width: 100%; text-align: -webkit-center">
                          <div class="smallerFont" style="padding-bottom: 20px; text-align: center" *ngIf="payType=='C'">Please enter billing information  as it appears on your credit card statement. Note: No periods, commas or special characters are allowed</div>


                          <div  *ngIf="payType=='C'">

                            <div class="two-col">
                              <div class="col1">
                                <mat-form-field appearance="outline" style="width: 90%" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Name</mat-label>
                                  <input maxlength="30" [(ngModel)]="myUser.creditCard.username" oninput="this.value = this.value.toUpperCase()" matInput formControlName="name" />
                                  <mat-icon matSuffix *ngIf="f.name.errors && payType=='C'" style="padding-bottom: 0px; padding-right: 0px"><img style="vertical-align: center; " src="assets/check_circle-24px.svg" ></mat-icon>
                                  <mat-icon matSuffix *ngIf="!f.name.errors && payType=='C'"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                                </mat-form-field>

                              </div>

                              <div class="col2">
                                <mat-form-field appearance="outline" style="width: 90%" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Address 1</mat-label>
                                  <input maxlength="30" [(ngModel)]="myUser.creditCard.address_1" oninput="this.value = this.value.toUpperCase()" matInput formControlName="address"/>
                                  <mat-icon matSuffix *ngIf="f.address.errors && payType=='C'"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                                  <mat-icon matSuffix *ngIf="!f.address.errors && payType=='C'"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                                </mat-form-field>

                              </div>

                              <div class="col1">
                                <mat-form-field appearance="outline" style="width: 90%" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">City</mat-label>
                                  <input maxlength="30" [(ngModel)]="myUser.creditCard.city" oninput="this.value = this.value.toUpperCase()" matInput formControlName="city"/>
                                  <mat-icon matSuffix *ngIf="f.city.errors && payType=='C'"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                                  <mat-icon matSuffix *ngIf="!f.city.errors && payType=='C'"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                                </mat-form-field>

                              </div>

                              <div class="col2">
                                <mat-form-field appearance="outline" style="width: 90%" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Address 2</mat-label>
                                  <input maxlength="30" [(ngModel)]="myUser.creditCard.address_2" oninput="this.value = this.value.toUpperCase()" matInput formControlName="address2"/>
                                </mat-form-field>

                              </div>


                              <div class="col1">
                                <mat-form-field appearance="outline" style="width: 50%; min-width: 99%" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">State/Region</mat-label>
                                  <mat-select  [(value)]="stateRegion" >
                                    <mat-option style="font-weight: bolder" *ngFor="let lr of stateRegions" [value]="lr.code">{{lr.description}}</mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>
                              <div class="col2" >
                                <mat-form-field appearance="outline" style="width: 50%; min-width: 99%" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Country</mat-label>
                                  <mat-select  [(value)]="country" (selectionChange)="changeCountry()" >
                                    <mat-option style="font-weight: bolder" *ngFor="let lr of countries" [value]="lr.code">{{lr.description}}</mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>

                              <div class="col1">
                                <mat-form-field appearance="outline" style="width: 90%" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Zip Code</mat-label>
                                  <input maxlength="5" [(ngModel)]="myUser.creditCard.zip" oninput="this.value = this.value.toUpperCase()" matInput formControlName="zip" />
                                  <mat-icon matSuffix *ngIf="f.zip.errors && payType=='C'"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                                  <mat-icon matSuffix *ngIf="!f.zip.errors && payType=='C'"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                                </mat-form-field>

                              </div>

                              <div class="col2">
                                <mat-form-field appearance="outline" style="width: 90%" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Email Address</mat-label>
                                  <input maxlength="30" [(ngModel)]="myUser.creditCard.email"  oninput="this.value = this.value.toUpperCase()" matInput formControlName="email" />
                                  <mat-icon matSuffix *ngIf="f.email.errors && payType=='C'"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                                  <mat-icon matSuffix *ngIf="!f.email.errors && payType=='C'"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                                </mat-form-field>

                              </div>
                            </div>
                          </div>
                        </div>

                      </form>


                      <div style="padding-top: 20px;" *ngIf="payType=='G'">

                        <div class="two-col">
                          <div class="col1">
                            <mat-form-field appearance="outline" style="width: 90%" floatLabel="always">
                              <mat-label style="font-size: 18px; color: #E61E00">Steamship Line</mat-label>
                              <input [(ngModel)]="myUser.company_name"  matInput readonly />
                            </mat-form-field>

                          </div>

                          <div class="col2">
                            <mat-form-field appearance="outline" style="width: 90%" floatLabel="always">
                              <mat-label style="font-size: 18px; color: #E61E00">Address 1</mat-label>
                              <input [(ngModel)]="myUser.address_1"  matInput/>
                            </mat-form-field>

                          </div>

                          <div class="col1">
                            <mat-form-field appearance="outline" style="width: 90%" floatLabel="always">
                              <mat-label style="font-size: 18px; color: #E61E00">City</mat-label>
                              <input  [(ngModel)]="myUser.city"  matInput readonly/>
                            </mat-form-field>
                          </div>
                          <div class="col2">
                            <mat-form-field appearance="outline" style="width: 90%" >
                              <mat-label style="font-size: 18px; color: #E61E00">Address 2</mat-label>
                              <input  [(ngModel)]="myUser.address_2"  matInput readonly/>
                            </mat-form-field>
                          </div>


                          <div class="col1">
                            <mat-form-field appearance="outline" style="width: 90%" floatLabel="always">
                              <mat-label style="font-size: 18px; color: #E61E00">State</mat-label>
                              <input  [(ngModel)]="myUser.state"  matInput readonly/>
                            </mat-form-field>
                          </div>
                          <div class="col2">
                            <mat-form-field appearance="outline" style="width: 90%" floatLabel="always">
                              <mat-label style="font-size: 18px; color: #E61E00">Zip Code</mat-label>
                              <input  [(ngModel)]="myUser.zip"  matInput readonly/>
                            </mat-form-field>
                          </div>


                          <div class="col1">
                            <mat-form-field appearance="outline" style="width: 90%" floatLabel="always">
                              <mat-label style="font-size: 18px; color: #E61E00">Email Address</mat-label>
                              <input [(ngModel)]="myUser.email_address"  matInput readonly />
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      </mat-card>




                      <div style="padding-top: 25px"></div>
                      <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);left: 0%; min-width: 97%; max-width: 97%; padding-bottom: 15px " xmlns="http://www.w3.org/1999/html">



                      <div class="divCC" *ngIf="payType=='C'"  >
                        <div style="background-color: black; padding: 5px;  max-width: 100%">
                          <div class="titleFont" style="padding-bottom: 10px; padding-top: 10px; text-align: center; color: white">Step 3: Payment Information</div>
                        </div>

                        <div style="vertical-align: top;height: 100%; max-width: 100%; text-align: -webkit-center">

                          <div class="col1" style="max-width: 100%; padding-top: 15px">
                            <mat-label >
                              <table style="width: 25%; height: 100%; text-align: center">


                                <tr>
                                  <mat-radio-group  [(ngModel)]="ccType">
                                    <td style="border: black 1px solid">
                                      <img  src="assets/visa.png" >
                                      <div>
                                        <mat-radio-button style="padding-left: 7px" value="V"></mat-radio-button>
                                      </div>
                                    </td>
                                    <td style="border: black 1px solid">
                                      <img  src="assets/mc.png" >
                                      <div>
                                        <mat-radio-button style="padding-left: 7px" value="M" ></mat-radio-button>
                                      </div>
                                    </td>
                                    <td style="border: black 1px solid">
                                      <img  src="assets/amex.png" >
                                      <div>
                                        <mat-radio-button style="padding-left: 7px" value="A" ></mat-radio-button>
                                      </div>
                                    </td>
                                    <td style="border: black 1px solid">
                                      <img  src="assets/discover.png" >
                                      <div>
                                        <mat-radio-button style="padding-left: 7px" value="D" ></mat-radio-button>
                                      </div>
                                    </td>
                                  </mat-radio-group>

                                </tr>

                              </table>
                            </mat-label>
                          </div>
                          <div class="smallerFont" *ngIf="submitted && noCC" style="color:#E61E00; font-weight: bolder">Please choose a Credit Card Type</div>

                          <form  [formGroup]="myForm2"  autocomplete="off" style="text-align: -webkit-center;text-align: -moz-center;"   novalidate>

                            <div class="col1"  style="max-width: 100%">
                              <mat-form-field appearance="outline" style="min-width: 89%" floatLabel="always">
                                <mat-label style="font-size: 18px; color: #E61E00">Card Number</mat-label>
                                <input maxlength="19"  oninput="this.value = this.value.toUpperCase()" matInput formControlName="ccNum" />
                                <mat-icon matSuffix *ngIf="g.ccNum.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                                <mat-icon matSuffix *ngIf="!g.ccNum.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                              </mat-form-field>


                            </div>

                            <div class="two-col">
                              <div class="col1">
                                <mat-form-field  appearance="outline" style="min-width: 99%" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Month</mat-label>
                                  <mat-select  [(value)]="month" >
                                    <mat-option style="font-weight: bolder"  *ngFor="let lr of months" [value]="lr.code">{{lr.description}}</mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>
                              <div class="col2">
                                <mat-form-field  appearance="outline" style="min-width: 99%" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Year</mat-label>
                                  <mat-select  [(value)]="year"   >
                                    <mat-option style="font-weight: bolder" *ngFor="let lr of years" [value]="lr.code">{{lr.description}}</mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>

                              <div class="col1" >
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Security Code</mat-label>
                                  <input maxlength="4"  oninput="this.value = this.value.toUpperCase()" matInput formControlName="secCode"/>
                                  <mat-icon matSuffix *ngIf="g.secCode.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                                  <mat-icon matSuffix *ngIf="!g.secCode.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                                </mat-form-field>
                                <span>

                        </span>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>


                      <div class="divCC" *ngIf="payType=='G'"  >
                        <div style="background-color: black; padding: 5px;  max-width: 100%">
                          <div class="titleFont" style="padding-bottom: 10px; padding-top: 10px; text-align: center; color: white">Step 3: Payment Information</div>
                        </div>

                        <div style="vertical-align: top; height: 100%; max-width: 100%">

                          <div class="col1" style="max-width: 100%; padding-top: 15px">
                            <div><img style="height: 125px;" src="assets/guaranteeBig.png" ></div>
                          </div>


                          <div class="two-col" style="max-width: 100%">
                            <div class="col1">
                              <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label style="font-size: 18px; color: #E61E00">Guarantor First Name</mat-label>
                                <input  [(ngModel)]="myUser.first_name"  matInput readonly/>
                              </mat-form-field>
                            </div>
                            <div class="col2">
                              <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label style="font-size: 18px; color: #E61E00">Guarantor Last Name</mat-label>
                                <input [(ngModel)]="myUser.last_name"  matInput readonly/>
                              </mat-form-field>
                            </div>

                            <div class="col1">
                              <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label style="font-size: 18px; color: #E61E00">Account Code</mat-label>
                                <input  [(ngModel)]="myUser.company_code"  matInput readonly/>
                              </mat-form-field>
                            </div>
                          </div>

                        </div>
                      </div>
                      </mat-card>


                      <div style="padding-top: 25px"></div>
                      <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);left: 0%; min-width: 97%; max-width: 97%; padding-bottom: 15px; padding-top: 15px " xmlns="http://www.w3.org/1999/html">

                      <div class="two-col" style="max-width: 100%">
                        <div class="col1" style="max-width: 50%; text-align: left">
                          <div class="titleFont" ><button mat-button (click)="returnToSelection()"  class="redButton" style="min-width: 90%; margin-left: 5px"> Return</button></div>
                        </div>
                        <div class="col2" style="max-width: 50%; text-align: right">
                          <div class="titleFont" ><button mat-button (click)="processComplete()"  class="blueButton"  style="min-width: 90%; margin-right: 5px"> Submit Order</button></div>
                        </div>
                      </div>
                      </mat-card>




                    </td>
                  </tr>
                </table>
                </div>


                <div *ngIf="showConfirmationScreen">

                <table style="width: 100%; min-height: 100%; padding-top: 10px">
                  <tr>
                    <td style="width: 90%;">
                      <table style="width: 100%">
                        <tr>
                          <td style="width: 50%;text-align: left">
                            <div class="titleFont" style="font-size: 19px">Confirmation

                            </div>

                          </td>
                          <td style="width: 50%; text-align: right">
                            <div class="titleFont" style="padding-left: 3%; font-size: 16px">Date: <a style="color: green">{{today2 | date:'MM-dd-yyyy hh:mm'}}</a></div>
                          </td>
                        </tr>
                      </table>



                      <table style="width: 100%; min-height: 100%; padding: 0px; margin: 0px">
                        <tr>
                          <td style="width: 85%; height: 100%; text-align: center;" >
                            <table  class="table-fill" style="height: 100%">
                              <tr>



                                <td style="vertical-align: top; height: 100%; max-width: 50%">



                               <span *ngFor="let xx of contGuarArray" >
                                              <div style="padding-top: 8%">
                                                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);left: 0%; min-width: 100%; max-width: 100%; padding-bottom: 3% " xmlns="http://www.w3.org/1999/html">

                                                  <div style="text-align: -webkit-center; height: 35px;text-align: -moz-center;">
                                                    <div *ngIf="xx.status.toUpperCase()=='SUCCESSFUL'" class="success"></div>
                                                    <div *ngIf="xx.status.toUpperCase()!='SUCCESSFUL'" class="problem"></div>
                                                  </div>
                                                  <div style="text-align: -webkit-center">
                                                    <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px"> {{xx.chargeEvent}} Charge</div>
                                                  </div>

                                                 <div *ngIf="xx.status.toUpperCase()=='SUCCESSFUL'">
                                                  <mat-form-field  appearance="outline"  style="min-width: 95%" floatLabel="always">
                                                  <mat-label style="font-size: 20px; color: #E61E00">Status</mat-label>
                                                  <input  style="color: green" [(ngModel)]="xx.status"  matInput readonly/>
                                                </mat-form-field>
                                                 </div >



                                                 <div *ngIf="xx.status.toUpperCase()!='SUCCESSFUL'">
                                                        <mat-form-field  appearance="outline"  style="min-width: 95%" floatLabel="always">
                                                          <mat-label style="font-size: 20px; color: #E61E00">Status</mat-label>
                                                          <textarea style="max-height: 100px; min-height: 100px; color: red" [(ngModel)]="xx.status" matInput readonly></textarea>
                                                        </mat-form-field>
                                                  </div>



                                                 <div *ngIf="xx.status.toUpperCase()=='SUCCESSFUL'">
                                                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%" floatLabel="always">
                                                        <mat-label style="font-size: 20px; color: #E61E00">Confirmation #</mat-label>
                                                        <input *ngIf="xx.status.toUpperCase()=='SUCCESSFUL'" style="color: green" [(ngModel)]="xx.guaranteeID"  matInput readonly/>
                                                      </mat-form-field>

                                                      <div [hidden]="xx.chargeEvent!=null && (xx.chargeEvent.toUpperCase().includes('EXAM') && !xx.chargeEvent.toUpperCase().includes('REDELIVER')) || xx.isFlatRate=='Y'">
                                                          <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                                                            <mat-label style="font-size: 20px; color: #E61E00">Payment From</mat-label>
                                                            <input [(ngModel)]="xx.fromDate" matInput readonly/>
                                                          </mat-form-field>
                                                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%" floatLabel="always">
                                                            <mat-label style="font-size: 20px; color: #E61E00">Payment To</mat-label>
                                                            <input [(ngModel)]="xx.toDate" matInput/>
                                                        </mat-form-field>
                                                      </div>
                                                      <div *ngIf="payType=='C'">
                                                             <mat-form-field class="newField" appearance="outline"  style="min-width: 95%" floatLabel="always">
                                                                <mat-label style="font-size: 20px; color: #E61E00">C.C. Authorization</mat-label>
                                                                <input *ngIf="xx.status.toUpperCase()=='SUCCESSFUL'" style="color: green" [(ngModel)]="xx.creditCardAuthorizationID"  matInput readonly/>
                                                               <input *ngIf="xx.status.toUpperCase()!='SUCCESSFUL'" style="color: red" [(ngModel)]="xx.creditCardAuthorizationID"  matInput readonly/>
                                                            </mat-form-field>
                                                        </div>
                                                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%" floatLabel="always">
                                                            <mat-label style="font-size: 20px; color: #E61E00">Amount</mat-label>
                                                            <input [(ngModel)]="xx.totalAmountDisp" matInput />
                                                        </mat-form-field>

                                                        <div *ngIf="payType=='C'">
                                                              <mat-form-field class="newField" appearance="outline"  style="min-width: 95%" floatLabel="always">
                                                                  <mat-label style="font-size: 20px; color: #E61E00">C.C. Processing Fee</mat-label>
                                                                  <input [(ngModel)]="xx.totalFeesDisp" matInput />
                                                              </mat-form-field>
                                                               <mat-form-field class="newField" appearance="outline"  style="min-width: 95%" floatLabel="always">
                                                                  <mat-label style="font-size: 20px; color: #E61E00">Total Amount</mat-label>
                                                                  <input [(ngModel)]="xx.grandTotalAmountDisp" matInput />
                                                              </mat-form-field>
                                                        </div>
                                                 </div>
                          </mat-card>

                        </div>


                  </span>

                  <div *ngIf="contGuarArray.length>0" style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);left: 0%; min-width: 100%; max-width: 100%; " xmlns="http://www.w3.org/1999/html">
                      <div style="width: 100%; text-align: right; padding-top: 10px">
                        <p *ngIf="payType=='G'" style="text-align: -webkit-center; text-align: -moz-center;font-size: 20px; font-weight: bolder; margin: 0;">Total: {{grandTotalDisp}}</p>
                        <p *ngIf="payType=='C' && debitCardUsed" style="text-align: -webkit-center; text-align: -moz-center; font-size: 20px; font-weight: bolder; margin: 0;">Total: {{grandTotalDisp}}</p>
                        <p *ngIf="payType=='C' && !debitCardUsed" style="text-align: -webkit-center; text-align: -moz-center;font-size: 20px; font-weight: bolder; margin: 0;">Total: {{grandTotalWFeeDisp}}</p>
                      </div>
                    </mat-card>
                  </div>



                    <div style="padding-top: 8%"></div>

                                  <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);left: 0%; min-width: 100%; max-width: 100%; " xmlns="http://www.w3.org/1999/html">

                                  <div >
                                    <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Billing/Payment Information</div>

                                    <div>
                                      <div *ngIf="payType=='G'">
                                        <img style="height: 130px;" src="assets/guaranteeBig.png" >
                                      </div>
                                      <div *ngIf="payType=='C' && ccType=='V'">
                                        <img style="height: 87px;" src="assets/visaBig.png" >
                                      </div>
                                      <div *ngIf="payType=='C' && ccType=='M'">
                                        <img style="height: 87px;" src="assets/mcBig.png" >
                                      </div>
                                      <div *ngIf="payType=='C' && ccType=='A'">
                                        <img style="height: 87px;" src="assets/amexBig.png" >
                                      </div>
                                      <div *ngIf="payType=='C' && ccType=='D'">
                                        <img style="height: 87px;" src="assets/discoverBig.png" >
                                      </div>

                                      <div *ngIf="payType=='C'" style="padding-top: 20px">
                                        <div>
                                          <mat-form-field appearance="outline" floatLabel="always">
                                            <mat-label style="font-size: 20px; color: #E61E00">Account Number</mat-label>
                                            <input [(ngModel)]="myUser.creditCard.account_number"  matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                        <div >
                                          <mat-form-field appearance="outline" floatLabel="always">
                                            <mat-label style="font-size: 20px; color: #E61E00">Expiration Date</mat-label>
                                            <input [(ngModel)]="myUser.creditCard.expiration_month_year"  matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                        <div class="smallerFont" style="font-size: 15px;" >
                                          <b>Demurrage:</b>
                                          If container is not delivered by  <b style="font-size: 16px;">{{futureDayDisp}}</b>, pre-approval will be voided.<br>
                                          It will be necessary to re-process payment. Based on credit card rules, it should also be noted that voided pre-approvals may take between 7 to 12 days to be posted against your available credit line.
                                        </div>
                                      </div>
                                    </div>

                                    <div *ngIf="payType=='C'">
                                      <div style="padding-top: 2px">
                                        <mat-form-field appearance="outline" floatLabel="always">
                                          <mat-label style="font-size: 20px; color: #E61E00">Name</mat-label>
                                          <input  [(ngModel)]="myUser.creditCard.username"  matInput readonly/>
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline" floatLabel="always">
                                          <mat-label style="font-size: 20px; color: #E61E00">Address 1</mat-label>
                                          <input [(ngModel)]="myUser.creditCard.address_1"  matInput readonly/>
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline" floatLabel="always">
                                          <mat-label style="font-size: 20px; color: #E61E00">Address 2</mat-label>
                                          <input [(ngModel)]="myUser.creditCard.address_2"  matInput readonly/>
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline" floatLabel="always">
                                          <mat-label style="font-size: 20px; color: #E61E00">City</mat-label>
                                          <input [(ngModel)]="myUser.creditCard.city"  matInput readonly/>
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline" floatLabel="always">
                                          <mat-label style="font-size: 20px; color: #E61E00">State/Region</mat-label>
                                          <input [(ngModel)]="myUser.creditCard.state_region"  matInput readonly/>
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline" floatLabel="always">
                                          <mat-label style="font-size: 20px; color: #E61E00">Zip Code</mat-label>
                                          <input [(ngModel)]="myUser.creditCard.zip"  matInput readonly/>
                                        </mat-form-field>
                                      </div>

                                    </div>

                                    <div *ngIf="payType=='G'">
                                      <div style="padding-top: 2px">
                                        <mat-form-field appearance="outline" floatLabel="always">
                                          <mat-label style="font-size: 20px; color: #E61E00">Steamship Line</mat-label>
                                          <input  [(ngModel)]="myUser.company_name"  matInput readonly/>
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline" floatLabel="always">
                                          <mat-label style="font-size: 20px; color: #E61E00">Address 1</mat-label>
                                          <input [(ngModel)]="myUser.address_1"  matInput readonly/>
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline" floatLabel="always">
                                          <mat-label style="font-size: 20px; color: #E61E00">Address 2</mat-label>
                                          <input [(ngModel)]="myUser.address_2"  matInput readonly/>
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline" floatLabel="always">
                                          <mat-label style="font-size: 20px; color: #E61E00">City</mat-label>
                                          <input [(ngModel)]="myUser.city"  matInput readonly/>
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline" floatLabel="always">
                                          <mat-label style="font-size: 20px; color: #E61E00">State/Region</mat-label>
                                          <input [(ngModel)]="myUser.state"  matInput readonly/>
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline" floatLabel="always">
                                          <mat-label style="font-size: 20px; color: #E61E00">Zip Code</mat-label>
                                          <input [(ngModel)]="myUser.zip"  matInput readonly/>
                                        </mat-form-field>
                                      </div>


                                    </div>

                                  </div>
                                  </mat-card>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>



                    </td>
                  </tr>
                </table>
                </div>



                <div *ngIf="showInquiryScreen" style="padding-top: 2%">
                  <table style="width: 100%">
                    <tr>
                      <td style="width: 50%; text-align: -webkit-left; vertical-align: text-top">
                        <div class="titleFont" style="font-size: 17px">Delivered Date:<a style="color: green"> {{contView.delivered_date_fmt}}</a></div>
                      </td>
                      <td style="width: 50%; text-align: -webkit-right; vertical-align: text-top">
                        <div class="titleFont" style="font-size: 17px" *ngIf="contView.category!='EXPRT'">Freetime End:<a style="color: green"> {{contView.fte_date_fmt3}}</a></div>
                      </td>
                    </tr>
                  </table>

                  <div style="padding-top: 8%"></div>
                  <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                    <div style="text-align: -webkit-center; height: 35px;text-align: -moz-center;">
                      <div class="payment"></div>
                    </div>
                    <div style="text-align: -webkit-center">
                      <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Demurrage & Charges Information</div>
                    </div>

                    <div>
                      <mat-form-field appearance="outline"  >
                        <mat-label style="font-size: 18px; color: #E61E00">Discharge Date </mat-label>
                        <input [(ngModel)]="contView.received_date_fmt" matInput readonly />
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field appearance="outline"  >
                        <mat-label style="font-size: 18px; color: #E61E00">FreeTime Start </mat-label>
                        <input [(ngModel)]="contView.fte_start_date" matInput readonly />
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field appearance="outline"  >
                        <mat-label style="font-size: 18px; color: #E61E00">FreeTime End </mat-label>
                        <input [(ngModel)]="contView.fte_date_fmt4" matInput readonly />
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field appearance="outline"  >
                        <mat-label style="font-size: 18px; color: #E61E00">FreeTime Days </mat-label>
                        <input [(ngModel)]="contView.free_days" matInput readonly />
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field appearance="outline"  >
                        <mat-label style="font-size: 18px; color: #E61E00">Demurrage Balance Due </mat-label>
                        <input [(ngModel)]="contView.demurrageBalanceDue" matInput readonly />
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field appearance="outline"  >
                        <mat-label style="font-size: 18px; color: #E61E00">Demurrage Days </mat-label>
                        <input [(ngModel)]="contView.demurrageDays" matInput readonly />
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field appearance="outline"  >
                        <mat-label style="font-size: 18px; color: #E61E00">Power Balance Due</mat-label>
                        <input [(ngModel)]="contView.powerBalanceDue" matInput readonly />
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field appearance="outline" >
                        <mat-label style="font-size: 18px; color: #E61E00">Exams Balance Due</mat-label>
                        <input [(ngModel)]="contView.examTotal" matInput readonly/>
                      </mat-form-field>
                    </div>

                  </mat-card>





                  <div style="padding-top: 8%"></div>
                  <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                    <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                      <div class="container"></div>
                    </div>
                    <div style="text-align: -webkit-center">
                      <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">General Information</div>
                    </div>

                    <div>
                      <mat-form-field appearance="outline"  >
                        <mat-label style="font-size: 20px; color: #E61E00">Line Op </mat-label>
                        <input [(ngModel)]="contView.ssl_owner_description" matInput readonly />
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field appearance="outline"  >
                        <mat-label style="font-size: 20px; color: #E61E00">Line Id</mat-label>
                        <input [(ngModel)]="contView.line_description" matInput readonly />
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field appearance="outline" >
                        <mat-label style="font-size: 20px; color: #E61E00">LHT</mat-label>
                        <input [(ngModel)]="contView.iso_description" matInput readonly/>
                      </mat-form-field>
                    </div>

                  </mat-card>


                <div style="padding-top: 8%"></div>

                  <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                    <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                      <div class="vessel"></div>
                    </div>
                    <div style="text-align: -webkit-center">
                      <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Vessel Information</div>
                    </div>

                    <div>
                      <mat-form-field appearance="outline"  >
                        <mat-label style="font-size: 18px; color: #E61E00">Vessel </mat-label>
                        <input [(ngModel)]="contView.vesselDisplay" matInput readonly />
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field appearance="outline"  >
                        <mat-label style="font-size: 18px; color: #E61E00">Voyage</mat-label>
                        <input [(ngModel)]="contView.voyageDisplay" matInput readonly />
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field appearance="outline" >
                        <mat-label style="font-size: 18px; color: #E61E00">Port Of Discharge</mat-label>
                        <input [(ngModel)]="contView.port_of_discharge_description" matInput readonly/>
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field appearance="outline" >
                        <mat-label style="font-size: 18px; color: #E61E00">Port Of Loading</mat-label>
                        <input [(ngModel)]="contView.port_of_loading_description" matInput readonly/>
                      </mat-form-field>
                    </div>

                  </mat-card>
                </div>


                <div *ngIf="showPhoneVoidScreen">

                  <div class="smallerFont" style="font-size: 15px; padding-top: 5px" >
                    Select payments to void; scroll to bottom of the screen and hit Void Selected button.,
                  </div>

                  <span *ngFor="let xx of contView.guaranteesArray" >
                        <div style="padding-top: 10%">
                          <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">

                            <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                              <button mat-button *ngIf="!selection3.isSelected(xx)" (click)="masterToggleVoid(xx,selection3.isSelected(xx)) ? selection3.toggle(xx) : null"  class="blueButton"  style="min-width: 100%; margin-right: 5px; font-size: 15px">Not Selected (Tap To Select)</button>
                              <button mat-button *ngIf="selection3.isSelected(xx)" (click)="masterToggleVoid(xx,selection3.isSelected(xx)) ? selection3.toggle(xx) : null"  class="redButton"  style="min-width: 100%; margin-right: 5px; font-size: 15px">Selected (Tap To DeSelect)</button>



                            </div>
                            <div style="text-align: -webkit-center">
                              <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px; padding-top: 5px"> {{xx.event_type_description + ' ' + xx.voided_or_expired_date_disp}} </div>
                            </div>

                              <mat-form-field  appearance="outline"  style="min-width: 95%" floatLabel="always">
                              <mat-label style="font-size: 20px; color: #E61E00">Status</mat-label>
                              <input   [(ngModel)]="xx.voided_or_expired_date_disp"  matInput readonly/>
                            </mat-form-field>

                            <mat-form-field  appearance="outline"  style="min-width: 95%" floatLabel="always">
                              <mat-label style="font-size: 20px; color: #E61E00">Amount</mat-label>
                              <input   [(ngModel)]="xx.guarantee_amount"  matInput readonly/>
                            </mat-form-field>


                            <div *ngIf="xx.guarantee_start_day!=null">
                                  <mat-form-field  appearance="outline"  style="min-width: 95%" floatLabel="always">
                                    <mat-label style="font-size: 20px; color: #E61E00">Payment From</mat-label>
                                    <input   [(ngModel)]="xx.guarantee_start_day"  matInput readonly/>
                                  </mat-form-field>

                                    <mat-form-field  appearance="outline"  style="min-width: 95%" floatLabel="always">
                                    <mat-label style="font-size: 20px; color: #E61E00">Payment To</mat-label>
                                    <input   [(ngModel)]="xx.guarantee_end_day"  matInput readonly/>
                                  </mat-form-field>
                            </div>


                            <mat-form-field  appearance="outline"  style="min-width: 95%" floatLabel="always">
                              <mat-label style="font-size: 20px; color: #E61E00">Category</mat-label>
                              <input   [(ngModel)]="xx.category_description"  matInput readonly/>
                            </mat-form-field>
                            <mat-form-field  appearance="outline"  style="min-width: 95%" floatLabel="always">
                              <mat-label style="font-size: 20px; color: #E61E00">Line Op</mat-label>
                              <input   [(ngModel)]="xx.sslDisp"  matInput readonly/>
                            </mat-form-field>
                            <mat-form-field  appearance="outline"  style="min-width: 95%" floatLabel="always">
                              <mat-label style="font-size: 20px; color: #E61E00">Vessel/Voyage</mat-label>
                              <input   [(ngModel)]="xx.vesselVoyageDisp"  matInput readonly/>
                            </mat-form-field>


                          </mat-card>
                        </div>
                  </span>
                  <div style="padding-top: 25px"></div>
                  <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);; min-width: 95%; max-width: 95%; padding-bottom: 15px; padding-top: 15px " xmlns="http://www.w3.org/1999/html">
                      <div class="col2" >
                        <div class="errorDiv2 flash" style="padding-bottom: 5px" *ngIf="nothingSelected && submitted">Must Select At Least One Record</div>
                        <div class="titleFont" ><button mat-button (click)="voidButtonHit()"  class="blueButton"  style="min-width: 90%; margin-right: 5px">Void Selected</button></div>
                      </div>
                  </mat-card>


                </div>



                <div *ngIf="showVoidConfirmationScreen">

                  <table style="width: 100%; min-height: 100%; padding-top: 10px">
                    <tr>
                      <td style="width: 90%;">
                        <table style="width: 100%">
                          <tr>
                            <td style="width: 50%;text-align: left">
                              <div class="titleFont" style="font-size: 19px">Confirmation</div>
                            </td>
                            <td style="width: 50%; text-align: right">
                              <div class="titleFont" style="padding-left: 3%; font-size: 16px">Date: <a style="color: green">{{today2 | date:'MM-dd-yyyy hh:mm'}}</a></div>
                            </td>
                          </tr>
                        </table>
                        <table style="width: 100%; min-height: 100%; padding: 0px; margin: 0px">
                          <tr>
                            <td style="width: 85%; height: 100%; text-align: center;" >
                              <table  class="table-fill" style="height: 100%">
                                <tr>
                                  <td style="vertical-align: top; height: 100%; max-width: 50%">
                                  <span *ngFor="let xx of guaranteeArray" >
                                              <div style="padding-top: 8%">
                                                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);left: 0%; min-width: 100%; max-width: 100%; padding-bottom: 3% " xmlns="http://www.w3.org/1999/html">

                                                  <div style="text-align: -webkit-center; height: 35px;text-align: -moz-center;">
                                                    <div *ngIf="xx.status.toUpperCase()=='SUCCESSFUL'" class="success"></div>
                                                    <div *ngIf="xx.status.toUpperCase()!='SUCCESSFUL'" class="problem"></div>
                                                  </div>
                                                  <div style="text-align: -webkit-center">
                                                    <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px"> {{xx.event_type_description}}</div>
                                                  </div>
                                                 <div *ngIf="xx.status.toUpperCase()=='SUCCESSFUL'">
                                                  <mat-form-field  appearance="outline"  style="min-width: 95%" floatLabel="always">
                                                  <mat-label style="font-size: 20px; color: #E61E00">Status</mat-label>
                                                  <input  style="color: green" [(ngModel)]="xx.status"  matInput readonly/>
                                                </mat-form-field>
                                                 </div >
                                                 <div *ngIf="xx.status.toUpperCase()!='SUCCESSFUL'">
                                                        <mat-form-field  appearance="outline"  style="min-width: 95%" floatLabel="always">
                                                          <mat-label style="font-size: 20px; color: #E61E00">Status</mat-label>
                                                          <textarea style="max-height: 100px; min-height: 100px; color: red" [(ngModel)]="xx.status" matInput readonly></textarea>
                                                        </mat-form-field>
                                                  </div>
                                                 <div *ngIf="xx.status.toUpperCase()=='SUCCESSFUL'">
                                                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%" floatLabel="always">
                                                        <mat-label style="font-size: 20px; color: #E61E00">Confirmation #</mat-label>
                                                        <input *ngIf="xx.status.toUpperCase()=='SUCCESSFUL'" style="color: green" [(ngModel)]="xx.guarantee_id"  matInput readonly/>
                                                      </mat-form-field>
                                                      <div [hidden]="xx.event_type_description!=null && (xx.event_type_description.toUpperCase().includes('EXAM') && !xx.event_type_description.toUpperCase().includes('REDELIVER')) ">
                                                          <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                                                            <mat-label style="font-size: 20px; color: #E61E00">Payment From</mat-label>
                                                            <input [(ngModel)]="xx.guarantee_start_day" matInput readonly/>
                                                          </mat-form-field>
                                                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%" floatLabel="always">
                                                            <mat-label style="font-size: 20px; color: #E61E00">Payment To</mat-label>
                                                            <input [(ngModel)]="xx.guarantee_end_day" matInput/>
                                                        </mat-form-field>

                                                      </div>

                                                   <mat-form-field class="newField" appearance="outline"  style="min-width: 95%" floatLabel="always">
                                                            <mat-label style="font-size: 20px; color: #E61E00">Amount</mat-label>
                                                            <input [(ngModel)]="xx.totalAmountDisp" matInput />
                                                    </mat-form-field>

                                                 </div>
                          </mat-card>










                        </div>
                          </span>
                                    <div *ngIf="guaranteeArray.length>0" style="padding-top: 8%">
                                      <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);left: 0%; min-width: 100%; max-width: 100%; " xmlns="http://www.w3.org/1999/html">
                                        <div style="width: 100%; text-align: right; padding-top: 10px">
                                          <p  style="text-align: -webkit-center; text-align: -moz-center;font-size: 20px; font-weight: bolder; margin: 0;">Total: {{grandTotalDisp}}</p>
                                        </div>
                                      </mat-card>
                                    </div>
                                    <div style="padding-top: 8%"></div>

                                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);left: 0%; min-width: 100%; max-width: 100%; " xmlns="http://www.w3.org/1999/html">

                                      <div >
                                        <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Voider Information</div>

                                        <div>
                                          <img style="height: 87px;" src="assets/void.png" >

                                          <div style="padding-top: 2px">
                                            <mat-form-field appearance="outline" floatLabel="always">
                                              <mat-label style="font-size: 20px; color: #E61E00">Steamship Line</mat-label>
                                              <input  [(ngModel)]="myUser.company_name"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" floatLabel="always">
                                              <mat-label style="font-size: 20px; color: #E61E00">Address 1</mat-label>
                                              <input [(ngModel)]="myUser.address_1"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" floatLabel="always">
                                              <mat-label style="font-size: 20px; color: #E61E00">Address 2</mat-label>
                                              <input [(ngModel)]="myUser.address_2"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" floatLabel="always">
                                              <mat-label style="font-size: 20px; color: #E61E00">City</mat-label>
                                              <input [(ngModel)]="myUser.city"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" floatLabel="always">
                                              <mat-label style="font-size: 20px; color: #E61E00">State/Region</mat-label>
                                              <input [(ngModel)]="myUser.state"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" floatLabel="always">
                                              <mat-label style="font-size: 20px; color: #E61E00">Zip Code</mat-label>
                                              <input [(ngModel)]="myUser.zip"  matInput readonly/>
                                            </mat-form-field>
                                          </div>




                                        </div>
                                      </div>
                                    </mat-card>

                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </div>



              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>
</div>





<table class="mainTable" style="width: 100%">
  <tr>
    <td class="mainUpperTd">
      <mat-card  class="quickView" *ngIf="showQuickView" >
        <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
          <tr>
            <td style="width: 95%; ">
              <div class="maher" (click)="myApp.showCharts()"></div>

              <mat-horizontal-stepper linear   labelPosition="bottom" #stepper class="stepper" >
                <mat-step disabled="true" [completed]="exists" >
                  <ng-template matStepLabel>Select</ng-template>
                  <div class="smallerFont" style="text-align: center" id="noPrint2">
                    Please check records you would like to authorize for payment and click Proceed To Checkout.
                  </div>
                  <span *ngIf="ipadView" class="smallerFont" style="padding-left: 85%; color: #E61E00" (click)="returnToSearch()">Back To Search</span>

                  <div class="flex-item2" >
                    <mat-table #table23 [dataSource]="quickViewData" multiTemplateDataRows matSort="container" >
                      <ng-container matColumnDef="check" >
                        <mat-header-cell *matHeaderCellDef  matTooltip="click to check/uncheck all" class="myHeader" style="padding-left: 5px; padding-right: 5px"><img (click)="checkAll('E')" style="vertical-align: center;height:26px; width: 26px" src="assets/check_circle_white.png" ></mat-header-cell>
                        <mat-cell style="padding-left: 2px" *matCellDef="let row">
                          <mat-checkbox [hidden]="row.charges.length==0 || row.charges.length>1 || row.maherError!=null" #mySel color="warn" (click)="$event.stopPropagation()"
                                        (change)="masterToggle(row,selection.isSelected(row)) ? selection.toggle(row) : null"
                                        [checked]="selection.isSelected(row)">
                          </mat-checkbox>
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="container" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Container</mat-header-cell>
                        <mat-cell [className]="(ipadView) ? 'ipadContainer' : 'nonipadContainer'" *matCellDef="let row">{{row.container}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="line_id" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Line Op</mat-header-cell>
                        <!--     <mat-cell [className]="row.available == 'Yes'? 'greenColor' : 'redColor'" *matCellDef="let row">{{row.line_id}}</mat-cell> -->
                        <mat-cell style="flex: 0 0 2.3% !important;" *matCellDef="let row">{{row.line_id}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="category_description" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Category</mat-header-cell>
                        <mat-cell style="flex: 0 0 5.1% !important;" *matCellDef="let row">{{row.category_description}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="vesselVoyage">
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Vessel/Voyage</mat-header-cell>
                        <mat-cell [className]="(row.maherError != null || row.navisErrors!=null) ? 'errorVesVoyage' : 'nonErrorVesVoyage'" [innerHTML]="row.vesselVoyage"   *matCellDef="let row" ></mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="booking" >`
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Booking</mat-header-cell>
                        <mat-cell [className]="(row.maherError != null || row.navisErrors!=null) ? 'errorBooking' : 'nonErrorBooking'"  *matCellDef="let row" >{{row.booking}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="chargeDisplay" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Charge Type</mat-header-cell>
                        <mat-cell [className]="(row.maherError != null || row.navisErrors!=null) ? 'errorCharge' : 'nonErrorCharge'" *matCellDef="let row">{{row.chargeDisplay}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="fte_date_fmt" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">{{fteColName}}</mat-header-cell>
                        <mat-cell [className]="(row.maherError != null || row.navisErrors!=null) ? 'errorFTE' : 'nonErrorFTE'"  *matCellDef="let row">{{row.fte_date_fmt2}}</mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="gDate" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">
                          <a style="padding-right: 50px; padding-left: 63px">Start/End</a>
                            <mat-icon matSuffix matTooltip="Apply Last Entered Date to ALL APPLICABLE records"><img  (click)="setAllDates()"  style="vertical-align: center; height: 20px; width: 20px;  padding-bottom: 2px; cursor: pointer" src="assets/copy.png" ></mat-icon>
                            <mat-icon matSuffix matTooltip="Erase ALL Dates" ><img (click)="clearAllDates()"  style="vertical-align: center; height: 20px; width: 20px;  padding-bottom: 2px; cursor: pointer" src="assets/eraser.png" ></mat-icon>
                 </mat-header-cell>


                        <mat-cell [className]="(row.maherError != null || row.navisErrors!=null) ? 'errorDate' : 'nonErrorDate'"  *matCellDef="let row">
                          <table style="min-width: 100%;max-width: 100%; text-align: -webkit-center">
                            <tr>
                              <td>
                          <mat-label style="min-width:fit-content; color: #E61E00" [hidden]="row.charges.length==0 ||row.charges.length>0 || row.maherError!=null || (row.chargeDisplay!=null && (row.chargeDisplay.toUpperCase().includes('EXAM') &&  !row.chargeDisplay.toUpperCase().includes('REDELIVER')))">Pick Up:&nbsp; </mat-label>
                          <mat-label style="min-width:fit-content; color: #E61E00; padding-right: 35px"  *ngIf="row.charges.length==1 && row.charges[0].flatRate=='Y'">Flat Rate Applied </mat-label>
                                <ng-container *ngIf="row.rangeMode">
                                  <mat-form-field  [className]="row.nothingGood ? 'dateBad' : 'dateGood'" *ngIf="showTheDateField(row)" style="display: block; font-size: 17px; font-weight: initial; width: 74%; height: 2.7vh; position: relative; top: -3px; font-family: almoni; left: 14px" >
                                    <mat-date-range-input style="position: relative; top: -17px; width: 130%"
                                                          [min]="row.start_datefmt"
                                                          [max]="row.end_datefmt"
                                                          [dateFilter]="dateFilter"
                                                          [rangePicker]="picker"
                                                          (dateChange)="emitDates($event,row,selection.isSelected(row))"
                                                          (click)="setupRow(row,row.charges[0].type,row.start_datefmt)"
                                                          (change)="typedDate(row)"
                                    >
                                      <input matStartDate matInput style="margin-top: 0"  [(ngModel)]="row.start_date_in" >
                                      <input matEndDate   matInput [(ngModel)]="row.end_date_in"  >
                                    </mat-date-range-input>
                                    <mat-date-range-picker   [startAt]="row.start_datefmt"  (opened)="onOpen()"    [dateClass]="dateClass()" #picker ></mat-date-range-picker>
                                    <mat-datepicker-toggle style="font-size: 37px; position: relative; top: -31px; right: -27%" (mousedown)="setupRow(row,row.charges[0].type,row.start_datefmt)"  matSuffix [for]="picker"></mat-datepicker-toggle>
                                  </mat-form-field>
                                </ng-container>

                                <ng-container *ngIf="!row.rangeMode">
                                  <mat-form-field  [className]="row.nothingGood ? 'dateBad' : 'dateGood'" *ngIf="showTheDateField(row)" style="display: block; font-size: 17px; font-weight: initial; width: 83%; height: 2.7vh; position: relative; top: -3px; font-family: almoni; left: -2px" >
                                      <input  matInput  style="margin-top:0; position: relative; top: -17px; width: 130%"

                                              [min]="row.start_datefmt"
                                              [max]="row.end_datefmt"
                                              [dateFilter]="dateFilter"
                                              [matDatepicker]="picker"
                                              (click)="setupRow(row,row.charges[0].type,row.start_datefmt)"
                                              (dateChange)="emitDates($event,row,selection.isSelected(row))"
                                              (change)="typedDate(row)"
                                              [(ngModel)]="row.start_date_in"
                                      >
                                    <mat-datepicker   [startAt]="row.start_datefmt"  (opened)="onOpen()"    [dateClass]="dateClass()" #picker  ></mat-datepicker>
                                    <mat-datepicker-toggle style="font-size: 37px; position: relative; top: -50px; left: 87%" (mousedown)="setupRow(row,row.charges[0].type,row.start_datefmt)" matsuffix [for]="picker"></mat-datepicker-toggle>
                                  </mat-form-field>
                                </ng-container>

                                <div style="display: none">
                            <div class="datepicker-footer" #datepickerFooter>

                              <table style="width: 100%; height:100%; border-top: #E61E00 solid 2px">
                                <tr >
                                  <td colspan="4" class="smallerFont" style="font-weight: bolder; color: #E61E00">legend</td>
                                </tr>
                                <tr>
                                  <td style="width: 5%">
                                    <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/guarantee.png" >
                                  </td>
                                  <td style="width: 30%">
                                    <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Guarantee</p>
                                  </td>
                                  <td style="width: 5%">
                                    <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/payment-24px.svg" >
                                  </td>
                                  <td style="width: 30%">
                                    <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Credit Card</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="width: 5%">
                                    <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/cash.png" >
                                  </td>
                                  <td style="width: 30%">
                                    <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Prepaid</p>
                                  </td>
                                  <td style="width: 5%">
                                    <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/waiver.jpg" >
                                  </td>
                                  <td style="width: 30%">
                                    <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Waived</p>
                                  </td>
                                </tr>
                              </table>

                            </div>
                          </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p *ngIf="row.nothingGood" class="invalidDate" style="margin-top: -12px; min-width: 58.2%; text-align: -webkit-center; color: white">{{xMsg}}</p>
                              </td>
                            </tr>

                          </table>
                        </mat-cell>

                      </ng-container>


                      <ng-container matColumnDef="reference_number" >
                        <mat-header-cell *matHeaderCellDef  class="myHeader">
                          <a style="padding-left: 20px; padding-right: 15px">{{refColName}}</a>
                          <mat-icon matSuffix ><img matTooltip="Apply Last Reference Number to ALL records" (click)="setAllReferenceNumbers()" style="vertical-align: center; height: 20px; width: 20px;  padding-bottom: 2px; cursor: pointer" src="assets/copy.png" ></mat-icon>
                          <mat-icon matSuffix ><img matTooltip="Erase ALL Reference Numbers" (click)="clearAllRefernenceNumbers()" style="vertical-align: center; height: 20px; width: 20px; padding-bottom: 2px; cursor: pointer" src="assets/eraser.png" ></mat-icon></mat-header-cell>
                        <mat-cell  [className]="(row.maherError != null || row.navisErrors!=null) ? 'errorRef' : 'nonErrorRef'" *matCellDef="let row">
                          <input [hidden]="row.charges.length==0 || row.charges.length>1 || row.maherError!=null || row.freight_kind=='MTY'" matInput [(ngModel)]="row.reference_number" (change)="makeSelected(row,selection.isSelected(row))"  style="vertical-align: super; border: black 1px solid; min-height: 26px; background-color: white; " >
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="remarks" >
                        <mat-header-cell *matHeaderCellDef  class="myHeader">
                          <a style="padding-right: 6px; padding-left: 12px">Remarks</a>
                          <mat-icon matSuffix ><img matTooltip="Apply Last Remark to ALL records" (click)="setAllRemarks()"  style="vertical-align: center; height: 20px; width: 20px;  padding-bottom: 2px; cursor: pointer" src="assets/copy.png" ></mat-icon>
                          <mat-icon matSuffix ><img matTooltip="Erase ALL Remarks" (click)="clearAllRemarks()"  style="vertical-align: center; height: 20px; width: 20px; padding-bottom: 2px; cursor: pointer" src="assets/eraser.png" ></mat-icon></mat-header-cell>
                        <mat-cell [className]="(row.maherError != null || row.navisErrors!=null)? 'errorRemarks' : 'nonErrorRemarks'"   *matCellDef="let row">
                          <input [hidden]="row.charges.length==0 || row.charges.length>1 || row.maherError!=null || row.freight_kind=='MTY'" matInput [(ngModel)]="row.remarks"  (change)="setLastRemark(row)"  style="vertical-align: super; border: black 1px solid; min-height: 26px; background-color: white; width: 98%" >
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="totalAmountMaher" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Maher Amt</mat-header-cell>
                        <mat-cell *matCellDef="let row" ><a [hidden]="row.totalAmountMaher==null">$</a>{{row.totalAmountMaher}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="totalAmountLine" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Line Op Amt</mat-header-cell>
                        <mat-cell *matCellDef="let row" ><a [hidden]="row.totalAmountLine==null"></a>{{row.totalAmountLine}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="totalAmountWithFee" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Amount</mat-header-cell>
                        <mat-cell *matCellDef="let row" ><a [hidden]="row.totalAmount==null">$</a>{{row.totalAmount}}</mat-cell>
                      </ng-container>


                      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                      <ng-container matColumnDef="expandedDetail">
                        <mat-cell class="newCell" *matCellDef="let row;let i = dataIndex" >
                          <div class="flex-item5" >

                            <mat-table #table3   [dataSource]="row.charges" multiTemplateDataRows matSort>
                              <ng-container matColumnDef="check" >
                                <mat-header-cell *matHeaderCellDef   class="myHeader2"></mat-header-cell>
                                <mat-cell style="flex: 0 0 2.5% !important; padding-left: 5px" *matCellDef="let row">
                                  <mat-checkbox #mySel2 color="warn" (click)="$event.stopPropagation()"
                                                (change)="masterToggle2(row,selection2.isSelected(row)) ? selection2.toggle(row) : null"
                                                [checked]="selection2.isSelected(row)">
                                  </mat-checkbox>
                                </mat-cell>
                              </ng-container>
                              <ng-container matColumnDef="type" >
                                <mat-header-cell *matHeaderCellDef  class="myHeader2"></mat-header-cell>
                                <mat-cell *matCellDef="let row;" ></mat-cell>
                              </ng-container>
                              <ng-container matColumnDef="typeDescription" >
                                <mat-header-cell *matHeaderCellDef   class="myHeader2"></mat-header-cell>
                                <mat-cell style="flex: 0 0 8.8% !important;" *matCellDef="let row">{{row.typeDescription}}</mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="fte_date_fmt" >
                                <mat-header-cell *matHeaderCellDef   class="myHeader2"></mat-header-cell>
                                <mat-cell style="flex: 0 0 5.5% !important;" *matCellDef="let row">{{row.fte_date_fmt}}</mat-cell>
                              </ng-container>
                              <ng-container matColumnDef="gDate" >
                                <mat-header-cell *matHeaderCellDef  class="myHeader2"></mat-header-cell>
                                <mat-cell style="padding: 2px; flex: 0 0 14.6% !important; padding-top: 12px"  *matCellDef="let row; "  >
                                  <table style="min-width: 100%;max-width: 100%; text-align: left">
                                    <tr>
                                      <td>
                                  <mat-label style="min-width:fit-content; color: #E61E00;"  *ngIf="row.flatRate=='Y'">Flat Rate Applied </mat-label>

                                        <mat-form-field [className]="row.nothingGood ? 'dateBad' : 'dateGood'"  *ngIf="showTheDateFieldCharges(row)" style="display: block; font-size: 17px; font-weight: initial; width: 74%; height: 2.7vh; position: relative; top: -3px; font-family: almoni; left: 16px" >
                                          <mat-date-range-input style="position: relative; top: -17px; width: 108%"
                                                                [rangePicker]="picker"
                                                                [min]="row.start_datefmt"
                                                                [max]="quickViewData.data[i].end_datefmt"
                                                                (click)="setupRow(row,row.type,row.start_datefmt)"
                                                                (dateChange)="emitDatesCharges($event,row,selection2.isSelected(row))"
                                                                (change)="typedDateCharge(row, row.type,quickViewData.data[i])"
                                                                [dateFilter]="dateFilter"
                                          >
                                            <input matStartDate matInput style="margin-top: 0"  [(ngModel)]="row.start_date_in"  (click)="setupRow(row,row.type,row.start_date_in)" (change)="typedDateCharge(row, row.type,quickViewData.data[i])">
                                            <input matEndDate   matInput [(ngModel)]="row.end_date_in" (dateChange)="emitDatesCharges($event,row,selection2.isSelected(row))"  (click)="setupRow(row,row.type,row.start_datefmt)" (change)="typedDateCharge(row, row.type,quickViewData.data[i])">
                                          </mat-date-range-input>
                                          <mat-date-range-picker   [startAt]="row.start_datefmt"  (opened)="onOpen()"   [hidden]="row.type!=null && (row.type.toUpperCase().includes('EXAM') && !row.type.toUpperCase().includes('REDELIVER')) || row.flatRate=='Y'" [dateClass]="dateClass()" #picker [rangeMode]="row.rangeMode" ></mat-date-range-picker>
                                          <mat-datepicker-toggle style="font-size: 37px; position: relative; top: -31px; right: -27%" [hidden]="row.type!=null && (row.type.toUpperCase().includes('EXAM') && !row.type.toUpperCase().includes('REDELIVER')) || row.flatRate=='Y'"  (mousedown)="setupRow(row,row.type,row.start_datefmt)"  matSuffix [for]="picker"></mat-datepicker-toggle>
                                        </mat-form-field>



                                  <div style="display: none">
                                    <div class="datepicker-footer" #datepickerFooter>

                                      <table style="width: 100%; height:100%; border-top: #E61E00 solid 2px">
                                        <tr >
                                          <td colspan="4" class="smallerFont" style="font-weight: bolder; color: #E61E00">legend</td>
                                        </tr>
                                        <tr>
                                          <td style="width: 5%">
                                            <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/guarantee.png" >
                                          </td>
                                          <td style="width: 30%">
                                            <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Guarantee</p>
                                          </td>
                                          <td style="width: 5%">
                                            <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/payment-24px.svg" >
                                          </td>
                                          <td style="width: 30%">
                                            <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Credit Card</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width: 5%">
                                            <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/cash.png" >
                                          </td>
                                          <td style="width: 30%">
                                            <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Prepaid</p>
                                          </td>
                                          <td style="width: 5%">
                                            <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/waiver.jpg" >
                                          </td>
                                          <td style="width: 30%">
                                            <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Waived</p>
                                          </td>
                                        </tr>
                                      </table>

                                    </div>
                                  </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <p *ngIf="row.nothingGood" class="invalidDate" style="margin-top: -12px; min-width: 59.2%; text-align: -webkit-center; color: white">{{xMsg}}</p>
                                      </td>
                                    </tr>

                                  </table>
                                </mat-cell>
                              </ng-container>
                              <ng-container matColumnDef="reference_number" >
                                <mat-header-cell *matHeaderCellDef  class="myHeader2"></mat-header-cell>
                                <mat-cell style="padding: 3px; padding-left: 2px; padding-right: 0px"   *matCellDef="let row">
                                  <input  matInput [(ngModel)]="row.reference_number" (change)="makeSelectedCharges(row,selection2.isSelected(row))" style="vertical-align: super; border: black 1px solid; min-height: 26px; background-color: white" >
                                </mat-cell>
                              </ng-container>
                              <ng-container matColumnDef="remarks" >
                                <mat-header-cell *matHeaderCellDef  class="myHeader2"></mat-header-cell>
                                <mat-cell  style="padding: 3px; padding-left: 1px; padding-right: 0px" *matCellDef="let row">
                                  <input  matInput [(ngModel)]="row.remarks" style="vertical-align: super; border: black 1px solid; min-height: 26px; background-color: white; width: 98%"   (change)="setLastRemark(row)" >
                                </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="amoutMaher" >
                                <mat-header-cell *matHeaderCellDef  class="myHeader2"></mat-header-cell>
                                <mat-cell *matCellDef="let row; let i = dataIndex">{{row.amoutMaher}}</mat-cell>
                              </ng-container>
                              <ng-container matColumnDef="amoutLine" >
                                <mat-header-cell *matHeaderCellDef  class="myHeader2"></mat-header-cell>
                                <mat-cell *matCellDef="let row; let i = dataIndex">{{row.amoutLine}}</mat-cell>
                              </ng-container>
                              <ng-container matColumnDef="amout" >
                                <mat-header-cell *matHeaderCellDef  class="myHeader2"></mat-header-cell>
                                <mat-cell *matCellDef="let row; let i = dataIndex">{{row.amout}}</mat-cell>
                              </ng-container>



                              <mat-header-row *matHeaderRowDef="chargeColumns; sticky: true"></mat-header-row>
                              <mat-row style="min-height: 26px;"    *matRowDef="let row; columns: chargeColumns;" style="background-color: rgba(217,198,14,0.05); border-bottom: black 1px dashed" class="table-row" ></mat-row>
                            </mat-table>


                          </div>
                        </mat-cell>
                      </ng-container>




                      <mat-header-row *matHeaderRowDef="getipadCols(); sticky: true"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: getipadCols();" style="border-top: #E61E00 2px solid;" class="topRow"></mat-row>
                      <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                               [className]="hideIt(row)? 'notVisible' : 'example-detail-row'"  ></mat-row>


                    </mat-table>

                    <table style="width: 100%; line-height: 10px">
                      <tr>
                        <td style="text-align: -webkit-left" *ngIf="showMaherStatement" >
                          <div class="lowerCaseLetters" style="font-size: 12px; text-align: left;"> Maher Statutory Statement</div>
                          <a style="font-family: almoni; font-weight: bold; font-size: 10px; text-transform: uppercase; white-space: break-spaces; line-height: 14px">As used herein, the term “Schedule” means Maher’s Terminal Schedule No. 010599, as amended and restated from time to time. The Schedule is publicly available on Maher’s website, <a href="http://www.maherterminals.com" target="_blank">www.maherterminals.com </a>, and is hereby incorporated in this Invoice by reference. The demurrage charges displayed on this Invoice are consistent with the Schedule and the rules of the Federal Maritime Commission related to marine terminal operator demurrage, including the rules contained in 46 CFR 545.5 and 46 CFR Part 541, as such rules may be applicable to Maher. In addition, the performance of Maher’s obligations with respect to the Cargo which forms the subject of this Invoice did not cause or otherwise contribute to the Demurrage charges set forth herein.
                          </a>
                        </td>
                        <td style="text-align: -webkit-left; width: 49%;" *ngIf="(myUser.role!=null && myUser.role!='LINEOP' && this.foundStorageSSL)">
                          <div class="lowerCaseLetters" style="font-size: 12px; text-align: left;"> Line Op Statutory Statement</div>
                          <a style="font-family: almoni; font-weight: bold; font-size: 10px; text-transform: uppercase; white-space: break-spaces; line-height: 14px">AS REQUIRED BY THE OCEAN SHIPPING REFORM ACT OF 2022, PUB. LAW NO. 117-146, THE OCEAN CARRIER ASSOCIATED WITH THE SUBJECT CONTAINER(S) HAS STATED THAT: (1) ITS DEMURRAGE CHARGES AGAINST SUCH CONTAINER(S) ARE CONSISTENT WITH THE RULES OF THE FEDERAL MARITIME COMMISSION WITH RESPECT TO DEMURRAGE, AND (2) ITS PERFORMANCE DID NOT CAUSE OR OTHERWISE CONTRIBUTE TO SUCH DEMURRAGE CHARGES. THE RATES ASSESSED BY THE CARRIER ARE SPECIFIED IN THAT CARRIER’S TARIFF PUBLISHED IN ACCORDANCE WITH THE RULES OF THE FEDERAL MARITIME COMMISSION; PLEASE REFER TO THE CARRIER’S TARIFF FOR FURTHER DETAILS.
                          </a>
                        </td>
                      </tr>
                      <tr>


                        <td  [className]="myUser.role!=null && myUser.role!='LINEOP' && this.foundStorageSSL ? 'toTheLeft' : 'toTheCenter'" *ngIf="(myUser.role!=null && myUser.role!='LINEOP'  && this.needToCheckOffStorageMaher)">
                          <a>
                            <mat-checkbox color="warn" (click)="$event.stopPropagation()"
                                          (change)="checkBoxFlipMaher()">
                            </mat-checkbox>
                          </a>
                          <a style="font-family: almoni; font-weight: bolder; color: #E61E00;  font-size: 11px; text-transform: uppercase; white-space: break-spaces; line-height: 14px; text-align: -webkit-left">
                            By checking off this box and clicking ‘Proceed to Checkout’, I agree that I have read and accepted the above Maher Terminals Statutory Statement.
                          </a>
                        </td>



                        <td style="text-align: -webkit-left; width: 49%;" *ngIf="(myUser.role!=null && myUser.role!='LINEOP' && needToCheckOffStorageSSL)">
                          <a>
                            <mat-checkbox color="warn" (click)="$event.stopPropagation()"
                                          (change)="checkBoxFlipLine()">
                            </mat-checkbox>
                          </a>
                          <a style="font-family: almoni; font-weight: bolder; color: #E61E00; font-size: 11px; text-transform: uppercase; white-space: break-spaces; line-height: 14px">
                            By checking off this box and clicking ‘Proceed to Checkout’, I agree that I have read and accepted the above Line OP Statutory Statement.
                          </a>
                        </td>
                      </tr>
                    </table>

                    <table style="width: 100%;">
                      <tr>
                        <td style="width: 72%; text-align: -webkit-center;">
                          <mat-paginator class="myPaginator" style="width: 80%" [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
                        </td>
                        <td>
                          <div >
                            <button mat-button matStepperNext (click)="verifySelection()" class="blueButton" [disabled]="!bothChecked" >Proceed To Checkout</button>

                          </div>
                        </td>
                        <td>
                          <button mat-raised-button matTooltip="Export To Excel"  (click)="exportExcel('E')"><img style="height: 38px"  src="assets/excel.png" ></button>

                        </td>
                      </tr>
                      <tr style="position: relative; top: -12px">
                        <td style="width: 72%;"></td>
                        <td>
                          <div >
                            <div class="errorDiv2 flash" *ngIf="nothingSelected && submitted">Must Select At Least One Record</div>
                            <div class="errorDiv2 flash" *ngIf="missingDate && submitted">Date Missing For {{containerOut}}</div>
                            <div class="errorDiv2 flash" *ngIf="badDate && submitted">Invalid Date For {{containerOut}}</div>
                            <div class="errorDiv2 flash" *ngIf="missingRef && submitted">Reference Number Missing For {{containerOut}}</div>
                            <div class="errorDiv2 flash" *ngIf="badChars && submitted">Invalid Character in Reference Number  For {{containerOut}}</div>
                            <div class="errorDiv2 flash" *ngIf="badRemarks && submitted">Invalid Character in Remarks  For {{containerOut}}</div>
                            <div class="errorDiv2 flash" *ngIf="missingBoth && submitted">Date and Reference Number Missing For {{containerOut}}</div>
                            <div class="errorDiv2 flash" *ngIf="maherError != null && submitted">{{maherError}}</div>
                          </div>
                        </td>
                        <td></td>
                      </tr>

                    </table>



                  <div class="smallerFont" style="font-weight: bold; padding-top: 2px; text-align:center">

                    Reminder About Extending Guarantees: If you have already entered an import storage guarantee and you wish to guarantee additional dates, you have the option of voiding your original guarantee and entering
                    a new guarantee to include the original dates guaranteed as well as the new dates. This way you will only receive one invoice. If you leave the original guarantee in place, and enter a new one for just the additional
                    dates, you will receive a separate invoice per transaction.
                  </div>

                  <div class="smallerFont" style="padding-top: 5px; font-weight: bold; text-align: center">
                    <a *ngIf="showCCMessage">
                      To cover the cost of credit card acceptance, we pass along a credit card charge of up to <a style="font-size:16px ">3.99%</a>, depending on whether the charge is made through VISA, Mastercard, Discover, or American Express. These fees are not more than our cost of accepting the applicable credit card.
                    </a>
                  </div>
                  </div>
                </mat-step>




                <mat-step disabled="true" [completed]="processed">
                  <ng-template matStepLabel>Checkout</ng-template>
                  <span *ngIf="ipadView" class="smallerFont" style="padding-left: 85%; color: #E61E00" (click)="returnToSearch()">Back To Search</span>

                  <table style="width: 100%; height: max-content; padding-bottom: 25px; padding-right: 25px" >
                    <tr>
                      <td style="width: 75%; height: 100%; text-align: -webkit-center">
                        <div style="background-color: black; padding: 5px; max-width: 90%">
                          <div class="titleFont" style="padding-bottom: 10px; padding-top: 10px; text-align: center; color: white">Step 1: Billing Information </div>
                        </div>

                        <form #billForm  [formGroup]="myForm"  autocomplete="off" style="text-align: -webkit-center;text-align: -moz-center;"   novalidate>


                          <div style="vertical-align: top;background-color: rgba(238,238,237,0.7); height: 100%; max-width: 91%">
                            <div class="smallerFont" style="padding-bottom: 20px; text-align: center" *ngIf="payType=='C'">Please enter billing information  as it appears on your credit card statement. Note: No periods, commas or special characters are allowed.</div>


                            <div  *ngIf="payType=='C'">

                              <div class="two-col">
                                <div class="col1">
                                  <mat-form-field appearance="outline" style="width: 90%">
                                    <mat-label>Name</mat-label>
                                    <input maxlength="30" [(ngModel)]="myUser.creditCard.username" oninput="this.value = this.value.toUpperCase()" matInput formControlName="name" />
                                    <mat-icon matSuffix *ngIf="f.name.errors && payType=='C'"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                                    <mat-icon matSuffix *ngIf="!f.name.errors && payType=='C'"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                                  </mat-form-field>

                                </div>

                                <div class="col2">
                                  <mat-form-field appearance="outline" style="width: 90%" >
                                    <mat-label>Address 1</mat-label>
                                    <input maxlength="30" [(ngModel)]="myUser.creditCard.address_1" oninput="this.value = this.value.toUpperCase()" matInput formControlName="address"/>
                                    <mat-icon matSuffix *ngIf="f.address.errors && payType=='C'"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                                    <mat-icon matSuffix *ngIf="!f.address.errors && payType=='C'"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                                  </mat-form-field>

                                </div>

                                <div class="col1">
                                  <mat-form-field appearance="outline" style="width: 90%">
                                    <mat-label>City</mat-label>
                                    <input maxlength="30" [(ngModel)]="myUser.creditCard.city" oninput="this.value = this.value.toUpperCase()" matInput formControlName="city"/>
                                    <mat-icon matSuffix *ngIf="f.city.errors && payType=='C'"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                                    <mat-icon matSuffix *ngIf="!f.city.errors && payType=='C'"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                                  </mat-form-field>

                                </div>

                                <div class="col2">
                                  <mat-form-field appearance="outline" style="width: 90%" >
                                    <mat-label>Address 2</mat-label>
                                    <input maxlength="30" [(ngModel)]="myUser.creditCard.address_2" oninput="this.value = this.value.toUpperCase()" matInput formControlName="address2"/>
                                  </mat-form-field>

                                </div>


                                <div class="col1" style="padding-top: 20px">
                                  <mat-form-field appearance="outline" style="width: 50%">
                                    <mat-label>State/Region</mat-label>
                                    <mat-select  [(value)]="stateRegion" >
                                      <mat-option style="font-weight: bolder" *ngFor="let lr of stateRegions" [value]="lr.code">{{lr.description}}</mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                                <div class="col2" style="padding-top: 20px">
                                  <mat-form-field appearance="outline" style="width: 50%">
                                    <mat-label>Country</mat-label>
                                    <mat-select  [(value)]="country" (selectionChange)="changeCountry()" >
                                      <mat-option style="font-weight: bolder" *ngFor="let lr of countries" [value]="lr.code">{{lr.description}}</mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>

                                <div class="col1">
                                  <mat-form-field appearance="outline" style="width: 90%">
                                    <mat-label>Zip Code</mat-label>
                                    <input maxlength="7" [(ngModel)]="myUser.creditCard.zip" oninput="this.value = this.value.toUpperCase()" matInput formControlName="zip" />
                                    <mat-icon matSuffix *ngIf="f.zip.errors && payType=='C'"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                                    <mat-icon matSuffix *ngIf="!f.zip.errors && payType=='C'"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                                  </mat-form-field>

                                </div>

                                <div class="col2">
                                  <mat-form-field appearance="outline" style="width: 90%">
                                    <mat-label>Email Address</mat-label>
                                    <input maxlength="255" [(ngModel)]="myUser.creditCard.email"  oninput="this.value = this.value.toUpperCase()" matInput formControlName="email" />
                                    <mat-icon matSuffix *ngIf="f.email.errors && payType=='C'"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                                    <mat-icon matSuffix *ngIf="!f.email.errors && payType=='C'"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                                  </mat-form-field>
                                  <div class="smallerFont" style="color: red; " *ngIf="isConsignee()">Please enter a valid email address that you would like the invoice copy sent to. </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </form>


                        <div style="padding-top: 20px;" *ngIf="payType=='G'">

                          <div class="two-col">
                            <div class="col1">
                              <mat-form-field appearance="outline" style="width: 90%">
                                <mat-label>Steamship Line</mat-label>
                                <input [(ngModel)]="myUser.company_name"  matInput readonly />
                              </mat-form-field>

                            </div>

                            <div class="col2">
                              <mat-form-field appearance="outline" style="width: 90%" >
                                <mat-label>Address 1</mat-label>
                                <input [(ngModel)]="myUser.address_1"  matInput/>
                              </mat-form-field>

                            </div>

                            <div class="col1">
                              <mat-form-field appearance="outline" style="width: 90%">
                                <mat-label>City</mat-label>
                                <input  [(ngModel)]="myUser.city"  matInput readonly/>
                              </mat-form-field>
                            </div>
                            <div class="col2">
                              <mat-form-field appearance="outline" style="width: 90%" >
                                <mat-label>Address 2</mat-label>
                                <input  [(ngModel)]="myUser.address_2"  matInput readonly/>
                              </mat-form-field>
                            </div>


                            <div class="col1">
                              <mat-form-field appearance="outline" style="width: 90%">
                                <mat-label>State</mat-label>
                                <input  [(ngModel)]="myUser.state"  matInput readonly/>
                              </mat-form-field>
                            </div>
                            <div class="col2">
                              <mat-form-field appearance="outline" style="width: 90%" >
                                <mat-label>Zip Code</mat-label>
                                <input  [(ngModel)]="myUser.zip"  matInput readonly/>
                              </mat-form-field>
                            </div>


                            <div class="col1">
                              <mat-form-field appearance="outline" style="width: 90%">
                                <mat-label>Email Address</mat-label>
                                <input [(ngModel)]="myUser.email_address"  matInput readonly />
                              </mat-form-field>
                            </div>
                          </div>
                        </div>





                        <div style="padding-top: 50px; background-color: rgba(238,238,237,0.7); max-width: 91%"></div>



                        <div class="divCC" *ngIf="payType=='C'"  >
                          <div style="background-color: black; padding: 5px;  max-width: 90%">
                            <div class="titleFont" style="padding-bottom: 10px; padding-top: 10px; text-align: center; color: white">Step 2: Payment Information</div>
                          </div>

                          <div style="vertical-align: top;background-color: rgba(23,122,241,0.07); height: 100%; max-width: 91%">

                            <div class="col1" style="max-width: 100%; padding-top: 15px">
                              <mat-label >
                                <table style="width: 25%; height: 100%; text-align: center">


                                  <tr>
                                    <mat-radio-group  [(ngModel)]="ccType" (click)="selectCCType()">
                                      <td style="border: black 1px solid">
                                        <img  src="assets/visa.png" >
                                        <div>
                                          <mat-radio-button style="padding-left: 7px" value="V"></mat-radio-button>
                                        </div>
                                      </td>
                                      <td style="border: black 1px solid">
                                        <img  src="assets/mc.png" >
                                        <div>
                                          <mat-radio-button style="padding-left: 7px" value="M" ></mat-radio-button>
                                        </div>
                                      </td>
                                      <td style="border: black 1px solid">
                                        <img  src="assets/amex.png" >
                                        <div>
                                          <mat-radio-button style="padding-left: 7px" value="A" ></mat-radio-button>
                                        </div>
                                      </td>
                                      <td style="border: black 1px solid">
                                        <img  src="assets/discover.png" >
                                        <div>
                                          <mat-radio-button style="padding-left: 7px" value="D" ></mat-radio-button>
                                        </div>
                                      </td>
                                    </mat-radio-group>

                                  </tr>

                                </table>
                              </mat-label>
                            </div>
                            <div class="smallerFont" *ngIf="submitted && noCC" style="color:#E61E00; font-weight: bolder">Please choose a Credit Card Type</div>

                            <form  [formGroup]="myForm2"  autocomplete="off" style="text-align: -webkit-center;text-align: -moz-center;"   novalidate>

                              <div class="col1"  style="max-width: 100%">
                                <mat-form-field appearance="outline" style="min-width: 89%">
                                  <mat-label>Card Number</mat-label>
                                  <input maxlength="19"   matInput formControlName="ccNum" (input)="setCCType()" />
                                  <mat-icon matSuffix *ngIf="g.ccNum.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                                  <mat-icon matSuffix *ngIf="!g.ccNum.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                                </mat-form-field>


                              </div>

                              <div class="two-col">
                                <div class="col1">
                                  <mat-form-field  appearance="outline" >
                                    <mat-label>Month</mat-label>
                                    <mat-select  [(value)]="month" >
                                      <mat-option style="font-weight: bolder"  *ngFor="let lr of months" [value]="lr.code">{{lr.description}}</mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                                <div class="col2">
                                  <mat-form-field  appearance="outline">
                                    <mat-label>Year</mat-label>
                                    <mat-select  [(value)]="year"   >
                                      <mat-option style="font-weight: bolder" *ngFor="let lr of years" [value]="lr.code">{{lr.description}}</mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>

                                <div class="col1" >
                                  <mat-form-field appearance="outline" style="min-width: 81%;max-width: 81%">
                                    <mat-label>Security Code</mat-label>
                                    <input maxlength="4"  oninput="this.value = this.value.toUpperCase()" matInput formControlName="secCode"/>
                                    <mat-icon matSuffix *ngIf="g.secCode.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                                    <mat-icon matSuffix *ngIf="!g.secCode.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                                  </mat-form-field>
                                  <span>
                            <a class="smallerFont" style="padding-left: 20px; font-weight: bold; cursor: pointer">Whats This?
                                <img style="height:220px; image-rendering: high-quality " src="assets/securityCC.jpg" />
                            </a>
                        </span>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>


                        <div class="divCC" *ngIf="payType=='G'"  >
                          <div style="background-color: black; padding: 5px;  max-width: 90%">
                            <div class="titleFont" style="padding-bottom: 10px; padding-top: 10px; text-align: center; color: white">Step 2: Payment Information</div>
                          </div>

                          <div style="vertical-align: top;background-color: rgba(23,122,241,0.07); height: 100%; max-width: 91%">

                            <div class="col1" style="max-width: 100%; padding-top: 15px">
                              <div><img style="height: 125px;" src="assets/guaranteeBig.png" ></div>
                            </div>


                            <div class="two-col" style="max-width: 100%">
                              <div class="col1">
                                <mat-form-field appearance="outline">
                                  <mat-label style="font-size: 18px; color: #E61E00">Guarantor First Name</mat-label>
                                  <input  [(ngModel)]="myUser.first_name"  matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div class="col2">
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Guarantor Last Name</mat-label>
                                  <input [(ngModel)]="myUser.last_name"  matInput readonly/>
                                </mat-form-field>
                              </div>

                              <div class="col1">
                                <mat-form-field appearance="outline">
                                  <mat-label style="font-size: 18px; color: #E61E00">Account Code</mat-label>
                                  <input  [(ngModel)]="myUser.company_code"  matInput readonly/>
                                </mat-form-field>
                              </div>
                            </div>

                          </div>
                        </div>


                      </td>
                      <td style="width: 25%; height: max-content;vertical-align: text-top; border: #E61E00 2px solid">
                        <div style="background-color: black; padding: 5px">
                          <div class="titleFont"  style="padding-bottom: 10px; padding-top: 10px; text-align: center; color: white">Order Summary</div>
                        </div>
                        <div class="scrollable" style="padding-top: 5px; border-bottom: solid">
                    <span *ngFor="let charges of contGuarArrayDisp;" >


                    <table style="width: 100%; height: min-content; vertical-align: top; ">
                      <tr>
                        <td  *ngIf="charges.container!=' '" style="text-align: center; width: 100%;" colspan="3">
                        </td>
                      </tr>

                      <tr>
                        <td style="text-align: center; width: 100%;" colspan="3">
                          <div class="titleFont" style="font-size: 25px; padding-top: 5px;text-decoration: underline; font-family: 'Open Sans'" *ngIf="charges.container!=' '">{{charges.container}}</div>
                        </td>
                      </tr>


                      <tr>
                        <td style="width: 10%">
                          <img style="height: 40px; width: 40px; padding-right: 10px; " *ngIf="charges.chargeEvent.toUpperCase()=='DEMURRAGE'" src="assets/cargo_container.png" >
                          <img style="height: 40px; width: 40px; padding-right: 10px; " *ngIf="charges.chargeEvent.toUpperCase()=='POWER'" src="assets/cold.png" >
                          <img style="height: 40px; width: 40px; padding-right: 10px;" *ngIf="charges.chargeEvent.toUpperCase().includes('SHIPSIDE')"  src="assets/vessel.png" >
                          <img style="height: 40px; width: 40px; padding-right: 10px;" *ngIf="charges.chargeEvent.toUpperCase().includes('COAST GUARD')"  src="assets/coast-guard.png" >
                          <img style="height: 40px; width: 40px; padding-right: 10px;" *ngIf="charges.chargeEvent.toUpperCase().includes('OFF')"  src="assets/offsite-icon.png" >
                          <img style="height: 40px; width: 40px; padding-right: 10px;" *ngIf="charges.chargeEvent.toUpperCase().includes('REDELIVERY')"  src="assets/export-redeliver.png" >


                        </td>
                        <td style="width: 70%; text-align: start">
                          <div class="titleFont" >{{charges.chargeEvent}}</div>
                        </td>
                        <td style="width: 20%; text-align: right; padding-right: 5px">
                          <div class="titleFont" *ngIf="payType=='C' && (ccType!=null && ccType!='V')" >{{charges.totalAmountWithFee}}</div>
                          <div class="titleFont" *ngIf="payType=='C' && (ccType!=null && ccType=='V')" >{{charges.totalAmountWithFeeVisa}}</div>
                          <div class="titleFont" *ngIf="payType=='C' && (ccType==null)" >{{charges.totalAmount}}</div>
                          <div class="titleFont" *ngIf="payType!='C'" >{{charges.totalAmount}}</div>
                        </td>
                      </tr>
                      <tr>

                        <td style="width: 10%">
                        </td>
                        <td style="width: 70%; text-align: start; vertical-align: top">
                          <span *ngFor="let children of charges.chargeDates" >
                            <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: 0px" *ngIf="charges.chargeEvent!=null && (!charges.chargeEvent.toUpperCase().includes('EXAM') || charges.chargeEvent.toUpperCase().includes('REDELIVERY')) && charges.flatRate!='Y'">{{children.description}}</div>
                          </span>
                          <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: 0px" *ngIf="charges.chargeEvent!=null && charges.chargeEvent.toUpperCase().includes('EXAM') && !charges.chargeEvent.toUpperCase().includes('REDELIVERY')">Exam Fee</div>
                          <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: 0px" *ngIf="charges.flatRate=='Y'">Flat Rate</div>
                          <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: 0px" *ngIf="payType=='C' && creditCardEntered && ccType!=null">Credit Card Fee</div>
                          <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: 0px" *ngIf="charges.chargeEvent!=null && charges.chargeEvent.toUpperCase().includes('DEMURRAGE') && charges.flatRate!='Y'">Maher Demurrage</div>
                          <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: 0px" *ngIf="charges.chargeEvent!=null && charges.chargeEvent.toUpperCase().includes('DEMURRAGE') && charges.totalAmountLine!=null && charges.flatRate!='Y'">Line Demurrage</div>
                        </td>
                        <td style="width: 20%; text-align: right; padding-right: 5px; vertical-align: top">
                          <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: -3px">&nbsp;</div>
                          <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: 0px" *ngIf="payType=='C' && creditCardEntered && (ccType!=null && ccType!='V')">{{charges.totalFees}}</div>
                          <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: 0px" *ngIf="payType=='C' && creditCardEntered && (ccType!=null && ccType=='V')">{{charges.totalFeesVisa}}</div>
                          <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: 0px" *ngIf="charges.chargeEvent!=null && charges.chargeEvent.toUpperCase().includes('DEMURRAGE') && charges.flatRate!='Y'">{{charges.totalAmountMaher}}</div>
                          <div class="smallerFont" style="font-size: 17px; font-weight: lighter; margin-top: 0px" *ngIf="charges.chargeEvent!=null && charges.chargeEvent.toUpperCase().includes('DEMURRAGE') && charges.totalAmountLine!=null && charges.flatRate!='Y'">{{charges.totalAmountLine}}</div>

                        </td>
                      </tr>

                      <tr>
                        <td  style="text-align: center; width: 100%; padding-bottom: 10px" colspan="3">
                        </td>
                      </tr>




                    </table>

                    </span>
                        </div>
                        <div style="height: 15.6%">
                          <table style="width: 100%; height: 100%; background-color: lightgrey;" attribute rules=none>
                            <tr>
                              <td style="width: 10%">
                              </td>
                              <td style="width: 70%; text-align: right; vertical-align:top; padding-right: 15px">
                                <div class="titleFont" *ngIf="payType=='C'">Subtotal: </div>
                                <div class="titleFont" *ngIf="payType=='C' && !ipadView && creditCardEntered && ccType!=null">C.C. Processing Fee: </div>
                                <div class="titleFont" *ngIf="payType=='C' && ipadView && creditCardEntered && ccType!=null">C.C. Fee: </div>
                                <div class="titleFont" *ngIf="creditCardEntered && ccType!=null">Grand Total:</div>
                              </td>
                              <td style="width: 20%; text-align: right; vertical-align: top; padding-right: 17px">
                                <div class="titleFont" *ngIf="payType=='C'">{{subTotalDisp}} </div>
                                <div class="titleFont" *ngIf="payType=='C' && creditCardEntered && (ccType!=null && ccType!='V')">{{totalFeesDisp}} </div>
                                <div class="titleFont" *ngIf="payType=='C' && creditCardEntered && (ccType!=null && ccType=='V')">{{totalFeesVisaDisp}} </div>
                                <div class="titleFont" *ngIf="payType=='C' && creditCardEntered && (ccType!=null && ccType!='V')" >{{grandTotalWFeeDisp}}</div>
                                <div class="titleFont" *ngIf="payType=='C' && creditCardEntered && (ccType!=null && ccType == 'V')" >{{grandTotalWFeeVisaDisp}}</div>
                                <div class="titleFont" *ngIf="payType!='C'" >{{grandTotalDisp}}</div>
                              </td>
                            </tr>


                          </table>
                        </div>


                      </td>
                    </tr>
                    <tr>
                      <td  style="text-align: left; padding-left: 50px; padding-top: 10px">
                        <div class="titleFont" ><button mat-button (click)="returnToSelection()" matStepperNext class="blueButton" > Return To Selection</button></div>
                      </td>
                      <td style="text-align: right; padding-top: 10px">
                        <div class="titleFont" ><button mat-button (click)="processComplete()" matStepperNext class="redButton" style="width: 100%"> Submit Order</button></div>
                      </td>
                    </tr>


                  </table>
                </mat-step>

                <mat-step  disabled="true" [completed]="allDone">
                  <ng-template matStepLabel>Confirmation</ng-template>
                  <div >
                    <table style="width: 100%; min-height: 100%; padding-top: 10px">
                      <tr>
                        <td style="width: 90%;">
                          <table style="width: 100%">
                            <tr>
                              <td style="width: 50%;text-align: left">
                                <div class="titleFont" style="font-size: 23px">Order Confirmation
                                  <span *ngIf="ipadView" class="smallerFont" style=" color: #E61E00; text-align: right; padding-left: 24%" (click)="returnToSearch()">Back To Search</span>

                                </div>

                              </td>
                              <td style="width: 50%; text-align: right">
                                <div class="titleFont" style="padding-left: 3%; font-size: 23px">Date: <a style="color: green">{{today2 | date:'MM-dd-yyyy hh:mm'}}</a></div>
                              </td>
                            </tr>
                          </table>
                          <table style="width: 100%; min-height: 100%; padding: 0px; margin: 0px">
                            <tr>
                              <td style="width: 85%; height: 100%; text-align: center;" >
                                <table  class="table-fill" style="height: 100%">
                                  <tr>



                                    <td style="vertical-align: top;background-color: rgba(238,238,237,0.7); border: #E61E00 1px solid; height: 100%; max-width: 50%">

                                      <div >
                                        <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Billing Information</div>

                                        <!-- <div class="two-col">
                                           <div class="col1">
                                               <p class="lowerCaseLetters">Name:</p>
                                           </div>

                                           <div class="col2">
                                             <p class="lowerCaseLetters">Cosco</p>

                                           </div>
                                         </div>-->

                                        <div *ngIf="payType=='C'">
                                          <div style="padding-top: 2px">
                                            <mat-form-field appearance="outline">
                                              <mat-label style="font-size: 18px; color: #E61E00">Name</mat-label>
                                              <input  [(ngModel)]="myUser.creditCard.username"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Address 1</mat-label>
                                              <input [(ngModel)]="myUser.creditCard.address_1"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Address 2</mat-label>
                                              <input [(ngModel)]="myUser.creditCard.address_2"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">City</mat-label>
                                              <input [(ngModel)]="myUser.creditCard.city"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">State/Region</mat-label>
                                              <input [(ngModel)]="myUser.creditCard.state_region"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Zip Code</mat-label>
                                              <input [(ngModel)]="myUser.creditCard.zip"  matInput readonly/>
                                            </mat-form-field>
                                          </div>

                                        </div>

                                        <div *ngIf="payType=='G'">
                                          <div style="padding-top: 2px">
                                            <mat-form-field appearance="outline">
                                              <mat-label style="font-size: 16px; color: #E61E00">Steamship Line</mat-label>
                                              <input  [(ngModel)]="myUser.company_name"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 16px; color: #E61E00">Address 1</mat-label>
                                              <input [(ngModel)]="myUser.address_1"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 16px; color: #E61E00">Address 2</mat-label>
                                              <input [(ngModel)]="myUser.address_2"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 16px; color: #E61E00">City</mat-label>
                                              <input [(ngModel)]="myUser.city"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 16px; color: #E61E00">State/Region</mat-label>
                                              <input [(ngModel)]="myUser.state"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 16px; color: #E61E00">Zip Code</mat-label>
                                              <input [(ngModel)]="myUser.zip"  matInput readonly/>
                                            </mat-form-field>
                                          </div>


                                        </div>

                                      </div>
                                    </td>
                                    <td  style="vertical-align: top;background-color:rgba(23,122,241,0.07); border: #E61E00 1px solid; height: 100%; vertical-align: top; max-width: 50%; width: 50%" >

                                      <div>
                                        <div  class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Payment Type</div>
                                        <div *ngIf="payType=='G'">
                                          <img style="height: 246px;" src="assets/guaranteeBig.png" >
                                        </div>
                                        <div *ngIf="payType=='C' && ccType=='V'">
                                          <img style="height: 87px;" src="assets/visaBig.png" >
                                        </div>
                                        <div *ngIf="payType=='C' && ccType=='M'">
                                          <img style="height: 87px;" src="assets/mcBig.png" >
                                        </div>
                                        <div *ngIf="payType=='C' && ccType=='A'">
                                          <img style="height: 87px;" src="assets/amexBig.png" >
                                        </div>
                                        <div *ngIf="payType=='C' && ccType=='D'">
                                          <img style="height: 87px;" src="assets/discoverBig.png" >
                                        </div>

                                        <div *ngIf="payType=='C'" style="padding-top: 20px">
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 16px; color: #E61E00">Account Number</mat-label>
                                              <input [(ngModel)]="myUser.creditCard.account_number"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div >
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 16px; color: #E61E00">Expiration Date</mat-label>
                                              <input [(ngModel)]="myUser.creditCard.expiration_month_year"  matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div class="smallerFont" style="font-size: 15px;">
                                            <b>Demurrage:</b>
                                            If container is not delivered by  <b style="font-size: 16px;">{{futureDayDisp}}</b> , pre-approval will be voided.<br>
                                            It will be necessary to re-process payment. Based on credit card rules, it should also be noted that voided pre-approvals may take between 7 to 12 days to be posted against your available credit line.
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>



                        </td>
                      </tr>
                    </table>
                    <div class="flex-item6" style="padding-top: 5px; background-color: rgba(238,238,237,0.7); border: #E61E00 1px solid;" id="printTable">
                      <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 5px ">Current Payments</div>
                      <mat-table #table23 [dataSource]="quickViewData6" multiTemplateDataRows matSort >
                        <ng-container matColumnDef="status" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Status</mat-header-cell>
                          <mat-cell  [className]="row.status.toUpperCase() == 'SUCCESSFUL' ? 'greenColor' : 'redColor'"*matCellDef="let row">{{row.status}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="guaranteeID" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Confirmation #</mat-header-cell>
                          <!--     <mat-cell [className]="row.available == 'Yes'? 'greenColor' : 'redColor'" *matCellDef="let row">{{row.line_id}}</mat-cell> -->
                          <mat-cell [className]="row.guaranteeID != null ? 'greenColor' : 'redColor'"  *matCellDef="let row">{{row.guaranteeID}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="container" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Container</mat-header-cell>
                          <mat-cell  *matCellDef="let row">{{row.container}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="chargeEvent" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Charge Type</mat-header-cell>
                          <mat-cell  *matCellDef="let row">{{row.chargeEvent}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="fromDate" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Payment From</mat-header-cell>
                          <mat-cell  *matCellDef="let row">{{row.fromDate}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="toDate" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Payment To</mat-header-cell>
                          <mat-cell  *matCellDef="let row">{{row.toDate}}</mat-cell>
                        </ng-container>
                        <ng-container  matColumnDef="creditCardAuthorizationID" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">C.C. Authorization</mat-header-cell>
                          <mat-cell [className]="row.creditCardAuthorizationID != null ? 'greenColor' : 'redColor'"  *matCellDef="let row">{{row.creditCardAuthorizationID}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="totalAmountMaherDisp" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Maher Amount</mat-header-cell>
                          <mat-cell  *matCellDef="let row">{{row.totalAmountMaherDisp}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="totalAmountLineDisp" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Line Op Amount</mat-header-cell>
                          <mat-cell  *matCellDef="let row">{{row.totalAmountLineDisp}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="totalAmountDisp" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Total Amount</mat-header-cell>
                          <mat-cell  *matCellDef="let row">{{row.totalAmountDisp}}</mat-cell>
                        </ng-container>
                        <ng-container  matColumnDef="totalFeesDisp" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">C.C. Processing Fee</mat-header-cell>
                          <mat-cell  *matCellDef="let row">{{row.totalFeesDisp}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="grandTotalAmountDisp" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Grand Total</mat-header-cell>
                          <mat-cell  *matCellDef="let row">{{row.grandTotalAmountDisp}}</mat-cell>
                        </ng-container>


                        <mat-header-row *matHeaderRowDef="getCorrectCols(); sticky: true"></mat-header-row>
                        <mat-row  *matRowDef="let row; columns: getCorrectCols();" style="min-height: 26px;background-color: rgba(238,238,237,0.7);" class="topRow" ></mat-row>

                      </mat-table>
                    </div>

                    <div style="width: 100%; text-align: right; padding-top: 10px">
                      <p *ngIf="payType=='G'" style="padding-left: 15px; padding-right: 71px; font-size: 14px; font-weight: bolder; margin: 0;">Total: {{grandTotalDisp}}</p>
                      <p *ngIf="payType=='C' && debitCardUsed" style="padding-left: 15px; padding-right: 71px; font-size: 14px; font-weight: bolder; margin: 0;">Total: {{grandTotalDisp}}</p>
                      <p *ngIf="payType=='C' && !debitCardUsed && ccType!='V'" style="padding-left: 15px; padding-right: 42px; font-size: 14px; font-weight: bolder; margin: 0;">Total: {{grandTotalWFeeDisp}}</p>
                      <p *ngIf="payType=='C' && !debitCardUsed && ccType=='V'" style="padding-left: 15px; padding-right: 42px; font-size: 14px; font-weight: bolder; margin: 0;">Total: {{grandTotalWFeeVisaDisp}}</p>

                    </div>

                    <div style="padding-top: 10px"></div>

                    <div class="flex-item7" style="padding-top: 10px; background-color: rgba(23,122,241,0.07); border: #E61E00 1px solid;"  id="printTable2">
                      <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 5px ">Payment History</div>

                      <mat-table #table23  [dataSource]="quickViewData3" multiTemplateDataRows matSort >

                        <ng-container matColumnDef="id" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Container</mat-header-cell>
                          <mat-cell style="flex: 0 0 17.7% !important;" *matCellDef="let row">{{row.id}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="event_type_description" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Charge Type</mat-header-cell>
                          <mat-cell style="flex: 0 0 16% !important;" *matCellDef="let row">{{row.event_type_description}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="guarantee_start_day" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Payment From</mat-header-cell>
                          <mat-cell style="flex: 0 0 16.3% !important;" *matCellDef="let row">{{row.guarantee_start_day}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="guarantee_end_day" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Payment To</mat-header-cell>
                          <mat-cell style="flex: 0 0 16.1% !important;" *matCellDef="let row">{{row.guarantee_end_day}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="created" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Payment Date</mat-header-cell>
                          <mat-cell style="flex: 0 0 15% !important;" *matCellDef="let row">{{row.created}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="voided_or_expired_date_disp" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Voided</mat-header-cell>
                          <mat-cell [className]="row.voided_or_expired_date_disp == 'Yes'? 'redColor' : 'greenColor'"  *matCellDef="let row">{{row.voided_or_expired_date_disp}}</mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="histColumn; sticky: true"></mat-header-row>
                        <mat-row  *matRowDef="let row; columns: histColumn;" style="min-height: 26px;background-color: rgba(23,122,241,0.07); " class="topRow" ></mat-row>

                      </mat-table>
                    </div>

                  </div>

                </mat-step>

              </mat-horizontal-stepper>


            </td>
            <td class="loginPic" style="">

            </td>
          </tr>
        </table>
      </mat-card>

      <mat-card class="quickView2" *ngIf="showQuickView2">
        <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
          <tr>
            <td style="width: 20%" >
              <div class="maher3" (click)="myApp.showCharts()"></div>
            </td>
            <td style="width: 80%">
              <div >
                <mat-form-field class="search"  appearance="outline">
                  <mat-label style="padding-left: 20px;">Search by Any Available Columns</mat-label>
                  <mat-icon matPrefix ><img style="vertical-align: center;height:25px; width: 25px" src="assets/cargo_container.png" ></mat-icon>
                  <input  maxlength="30" style="padding-left: 20px;"  matInput (keyup)="applyFilter($event.target.value)"  [formControl]="search1">
                </mat-form-field>
              </div>
              <div class="lowerCaseLetters" style="font-size: 14px; padding-left: 24%">Click On Any Row To View Details For The Container</div>
              <span *ngIf="ipadView" class="smallerFont" style="padding-left: 85%; color: #E61E00" (click)="returnToSearch()">Back To Search</span>

            </td>
          </tr>
        </table>

        <div class="flex-item2" >
          <mat-table #table23 [dataSource]="quickViewData" multiTemplateDataRows matSort="container" >
            <ng-container matColumnDef="container" >
              <mat-header-cell style="  flex: 0 0 16.1% !important;" *matHeaderCellDef mat-sort-header  class="myHeader">Container</mat-header-cell>
              <mat-cell style="  flex: 0 0 16.1% !important;" *matCellDef="let row">{{row.container}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="line_description">
              <mat-header-cell   style="  flex: 0 0 8% !important;" *matHeaderCellDef mat-sort-header  class="myHeader">Line Op</mat-header-cell>
              <mat-cell  style="  flex: 0 0 8% !important;" *matCellDef="let row">{{row.line_id}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="vesselVoyage" >
              <mat-header-cell style="  flex: 0 0 24% !important;" *matHeaderCellDef mat-sort-header  class="myHeader">Vessel/Voyage</mat-header-cell>
              <mat-cell [className]="(row.maherError != null || row.navisErrors!=null) ? 'errorVesVoyageInq' : 'nonErrorVesVoyageInq'"  *matCellDef="let row">{{row.vesselVoyage}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="category_description" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Category</mat-header-cell>
              <mat-cell *matCellDef="let row" [className]="(row.maherError != null || row.navisErrors!=null) ? 'errorCategory' : 'nonErrorCategory'">{{row.category_description}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="demurrageBalanceDueMaher" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Maher Demurrage</mat-header-cell>
              <mat-cell *matCellDef="let row" [className]="(row.maherError != null || row.navisErrors!=null) ? 'errorDemBal' : 'nonErrorDemBal'">{{row.demurrageBalanceDueMaher}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="demurrageBalanceDueLine" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Line Demurrage</mat-header-cell>
              <mat-cell *matCellDef="let row" [className]="(row.maherError != null || row.navisErrors!=null) ? 'errorDemBal' : 'nonErrorDemBal'">{{row.demurrageBalanceDueLine}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="demurrageBalanceDue" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Demurrage Balance</mat-header-cell>
              <mat-cell *matCellDef="let row" [className]="(row.maherError != null || row.navisErrors!=null) ? 'errorDemBal' : 'nonErrorDemBal'">{{row.demurrageBalanceDue}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="powerBalanceDue" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Power Balance</mat-header-cell>
              <mat-cell *matCellDef="let row" [className]="(row.maherError != null || row.navisErrors!=null) ? 'errorPowerBal' : 'nonErrorPowerBal'">{{row.powerBalanceDue}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="examTotal" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Exam Balance</mat-header-cell>
              <mat-cell *matCellDef="let row" [className]="(row.maherError != null || row.navisErrors!=null) ? 'errorExamBal' : 'nonErrorExamBal'">{{row.examTotal}}</mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="qvColumns2; sticky: true"></mat-header-row>
            <mat-row   *matRowDef="let row; columns: qvColumns2;" class="mat-row" (click)="showDetails(row)"></mat-row>
          </mat-table>
          <mat-toolbar style="width: 100%; display: unset">
            <mat-toolbar-row style="width: 100%; ">
              <mat-paginator class="myPaginator"  [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
              <span style="padding-left: 24%">
                  <button mat-raised-button matTooltip="Export To Excel"  (click)="exportExcel('I')"><img style="height: 38px"  src="assets/excel.png" ></button>
              </span>
            </mat-toolbar-row>
          </mat-toolbar>
        </div>
      </mat-card>



      <mat-card class="details" *ngIf="showDetailScreen">
        <table style="width: 100%; height: 100%">
          <tr>
            <td style="width: 90%;">


              <mat-card class="contDetails">


                <table style="width: 100%">
                  <tr>
                    <td style="width: 1%">
                      <div class="maher2" (click)="myApp.showCharts()"></div>
                    </td>

                    <td style="width: 20%">
                      <div class="titleFont" style="padding-left: 3%; font-size: 23px">Container:<a style="color: green"> {{contView.container}}</a></div>
                    </td>
                    <td style="width: 29%">
                      <div class="titleFont" style="padding-left: 3%; font-size: 23px">Delivered Date:<a style="color: green"> {{contView.delivered_date_fmt}}</a></div>
                    </td>
                    <td style="width: 20%">
                      <div class="titleFont" style="padding-left: 3%; font-size: 23px" *ngIf="contView.category!='EXPRT'">Freetime End Date:<a style="color: green"> {{contView.fte_date_fmt3}}</a></div>
                    </td>
                    <td style="width: 11%">
                      <div class="lowerCaseLetters" [hidden]="quickViewData.data.length==1" (click)="returnToQuickView()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Quick View</div>
                      <div class="lowerCaseLetters" *ngIf="quickViewData.data.length==1 && ipadView" (click)="returnToSearch()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Search</div>
                    </td>
                  </tr>
                </table>



                <table style="width: 100%; height: 100%; padding: 0px; margin: 0px">
                  <tr>
                    <td style="width: 85%; height: 100%; text-align: center;" >
                      <table  class="table-fill" style="height: 100%">
                        <tr>
                          <td style="vertical-align: top" >
                            <div style="background-color: rgba(238,238,237,0.7); border: #E61E00 1px solid; height: 99%">
                              <div >
                                <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 15px ">General Information</div>
                                <div>
                                  <mat-form-field appearance="outline" floatLabel="always"  >
                                    <mat-label style="font-size: 18px; color: #E61E00">Line Op </mat-label>
                                    <input [(ngModel)]="contView.ssl_owner_description" matInput readonly />
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline"  floatLabel="always">
                                    <mat-label style="font-size: 18px; color: #E61E00">Line Id</mat-label>
                                    <input [(ngModel)]="contView.line_description" matInput readonly />
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" floatLabel="always">
                                    <mat-label style="font-size: 18px; color: #E61E00">LHT</mat-label>
                                    <input [(ngModel)]="contView.iso_description" matInput readonly/>
                                  </mat-form-field>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td style="vertical-align: top" >
                            <div style="background-color: rgba(23,122,241,0.07); border: #E61E00 1px solid; height: 99%">
                              <div >
                                <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 15px ">Vessel Information</div>
                                <div>
                                  <mat-form-field appearance="outline"  floatLabel="always">
                                    <mat-label style="font-size: 18px; color: #E61E00">Vessel </mat-label>
                                    <input [(ngModel)]="contView.vesselDisplay" matInput readonly />
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" floatLabel="always" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Voyage</mat-label>
                                    <input [(ngModel)]="contView.voyageDisplay" matInput readonly />
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" floatLabel="always" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Port Of Discharge</mat-label>
                                    <input [(ngModel)]="contView.port_of_discharge_description" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" floatLabel="always">
                                    <mat-label style="font-size: 18px; color: #E61E00">Port Of Loading</mat-label>
                                    <input [(ngModel)]="contView.port_of_loading_description" matInput readonly/>
                                  </mat-form-field>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td style="vertical-align: top" >
                            <div style="background-color: rgba(238,238,237,0.7); border: #E61E00 1px solid; height: 100%">
                              <div >
                                <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 1%;padding-bottom: 15px ">Charges Information</div>
                                <table style="width: 100%">
                                  <tr>
                                    <td style="width: 50%">
                                      <div>
                                        <mat-form-field appearance="outline"  floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">Discharge Date </mat-label>
                                          <input [(ngModel)]="contView.received_date_fmt" matInput readonly />
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline"  floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">Maher Demurrage Balance </mat-label>
                                          <input [(ngModel)]="contView.demurrageBalanceDueMaher" matInput readonly />
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline"  floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">Line Demurrage Balance </mat-label>
                                          <input [(ngModel)]="contView.demurrageBalanceDueLine" matInput readonly />
                                        </mat-form-field>
                                      </div>

                                      <div>
                                        <mat-form-field appearance="outline"  floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">Total Demurrage Balance </mat-label>
                                          <input [(ngModel)]="contView.demurrageBalanceDue" matInput readonly />
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline"  floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">Power Balance Due</mat-label>
                                          <input [(ngModel)]="contView.powerBalanceDue" matInput readonly />
                                        </mat-form-field>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <mat-form-field appearance="outline"  floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">FreeTime Start </mat-label>
                                          <input [(ngModel)]="contView.fte_start_date" matInput readonly />
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline"  floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">FreeTime End </mat-label>
                                          <input [(ngModel)]="contView.fte_date_fmt4" matInput readonly />
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline"  floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">Free Days </mat-label>
                                          <input [(ngModel)]="contView.free_days" matInput readonly />
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline"  floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">Demurrage Days </mat-label>
                                          <input [(ngModel)]="contView.demurrageDays" matInput readonly />
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline" floatLabel="always" >
                                          <mat-label style="font-size: 18px; color: #E61E00">Exams Balance Due</mat-label>
                                          <input [(ngModel)]="contView.examTotal" matInput readonly/>
                                        </mat-form-field>
                                      </div>
                                    </td>
                                  </tr>

                                </table>








                              </div>
                            </div>
                          </td>

                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
                <table style="width: 100%;">
                  <tr>
                    <td style="width: 50%;">
                      <div class="lowerCaseLetters" style="font-size: 12px; text-align: left;"> Maher Statutory Statement</div>
                      <a style="font-family: almoni; font-weight: bold; font-size: 10px; text-transform: uppercase">
                        As used herein, the term “Schedule” means Maher’s Terminal Schedule No. 010599, as amended and restated from time to time. The Schedule is publicly available on Maher’s website, <a href="http://www.maherterminals.com" target="_blank">www.maherterminals.com </a>, and is hereby incorporated in this Invoice by reference. The demurrage charges displayed on this Invoice are consistent with the Schedule and the rules of the Federal Maritime Commission related to marine terminal operator demurrage, including the rules contained in 46 CFR 545.5 and 46 CFR Part 541, as such rules may be applicable to Maher. In addition, the performance of Maher’s obligations with respect to the Cargo which forms the subject of this Invoice did not cause or otherwise contribute to the Demurrage charges set forth herein.
                      </a>
                    </td>
                    <td *ngIf="(myUser.role!=null && myUser.role!='LINEOP' && this.foundStorageSSL)" style="vertical-align: super">
                      <div class="lowerCaseLetters" style="font-size: 12px; text-align: left;"> Line Op Statutory Statement</div>
                      <a style="font-family: almoni; font-weight: bold; font-size: 10px; text-transform: uppercase">
                        AS REQUIRED BY THE OCEAN SHIPPING REFORM ACT OF 2022, PUB. LAW NO. 117-146, THE OCEAN CARRIER ASSOCIATED WITH THE SUBJECT CONTAINER(S) HAS STATED THAT: (1) ITS DEMURRAGE CHARGES AGAINST SUCH CONTAINER(S) ARE CONSISTENT WITH THE RULES OF THE FEDERAL MARITIME COMMISSION WITH RESPECT TO DEMURRAGE, AND (2) ITS PERFORMANCE DID NOT CAUSE OR OTHERWISE CONTRIBUTE TO SUCH DEMURRAGE CHARGES. THE RATES ASSESSED BY THE CARRIER ARE SPECIFIED IN THAT CARRIER’S TARIFF PUBLISHED IN ACCORDANCE WITH THE RULES OF THE FEDERAL MARITIME COMMISSION; PLEASE REFER TO THE CARRIER’S TARIFF FOR FURTHER DETAILS.
                      </a>
                    </td>
                  </tr>
                </table>



                <div class="flex-item6" style="padding-top: 5px; background-color: rgba(238,238,237,0.7); border: #E61E00 1px solid;"  >
                  <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 0.7%;padding-bottom: 5px ">Payments By Current Account</div>
                  <mat-table #table23 [dataSource]="quickViewData3" multiTemplateDataRows matSort >
                    <ng-container matColumnDef="guarantee_amount_disp" >
                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Payment Amount</mat-header-cell>
                      <mat-cell  *matCellDef="let row">{{row.guarantee_amount_disp}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="totalFeesDisp" >
                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">C.C. Processing Fee</mat-header-cell>
                      <!--     <mat-cell [className]="row.available == 'Yes'? 'greenColor' : 'redColor'" *matCellDef="let row">{{row.line_id}}</mat-cell> -->
                      <mat-cell  *matCellDef="let row" >
                        <a *ngIf="row.card_type!='VISA'">{{row.totalFeesDisp}}</a>
                        <a *ngIf="row.card_type=='VISA'">{{row.totalFeesVisaDisp}}</a>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="totalAmountDisp" >
                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Total Amount</mat-header-cell>
                      <mat-cell  *matCellDef="let row">
                        <a *ngIf="row.card_type!='VISA'">{{row.totalAmountDisp}}</a>
                        <a *ngIf="row.card_type=='VISA'">{{row.totalAmountVisaDisp}}</a>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="eventTypeDisp" >
                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Payment Type</mat-header-cell>
                      <mat-cell  *matCellDef="let row">{{row.eventTypeDisp | titlecase}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="guarantee_start_day" >
                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Payment From</mat-header-cell>
                      <mat-cell  *matCellDef="let row">{{row.guarantee_start_day}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="guarantee_end_day" >
                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Payment To</mat-header-cell>
                      <mat-cell   *matCellDef="let row">{{row.guarantee_end_day}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="customer_reference_id" >
                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Reference</mat-header-cell>
                      <mat-cell *matCellDef="let row">{{row.customer_reference_id}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="guarantee_id" >
                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Confirmation</mat-header-cell>
                      <mat-cell   *matCellDef="let row">{{row.guarantee_id}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="n4_user_id" >
                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Payment By</mat-header-cell>
                      <mat-cell   *matCellDef="let row">{{row.n4_user_id}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="created" >
                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Payment Date</mat-header-cell>
                      <mat-cell  *matCellDef="let row">{{row.created}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="voided_or_expired_date_disp" >
                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Voided</mat-header-cell>
                      <mat-cell [className]="row.voided_or_expired_date_disp == 'Yes'? 'redColor' : 'greenColor'"  *matCellDef="let row">{{row.voided_or_expired_date_disp}}</mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="currentCol; sticky: true"></mat-header-row>
                    <mat-row  *matRowDef="let row; columns: currentCol;" style="min-height: 26px;background-color: rgba(238,238,237,0.7);" class="topRow" ></mat-row>

                  </mat-table>
                  <div class="lowerCaseLetters" style="font-size: 13px;padding-bottom: 10px; padding-top: 5px ">
                    <p style="text-align:left; padding-left: 2%; padding-top: 4px; padding-bottom: 10px; margin: 1px">
                      <span  [hidden]="quickViewData.data.length==1" style="float:right; font-size: 14px; color: #E61E00; cursor: pointer; padding-right: 4%" (click)="nextTransaction()">Next Container</span>
                      <span   [hidden]="quickViewData.data.length==1" style="float:right; font-size: 14px; color: #E61E00; cursor: pointer; padding-right: 4%" (click)="previousTransaction()">Previous Container</span>
                    </p>
                  </div>
                </div>


                <div class="flex-item8" style="padding-top: 5px; background-color: rgba(23,122,241,0.07); border: #E61E00 1px solid;"  *ngIf="guarGuarArrayOtherHist.length>0">
                  <div class="lowerCaseLetters" style="font-size: 13px; ">
                    <p style="text-align:left; padding-left: 0.7%; padding-top: 4px; padding-bottom: 5px; margin: 1px">
                      Payments By Other Accounts
                    </p>
                  </div>
                  <mat-table #table23  [dataSource]="quickViewData4" multiTemplateDataRows matSort >
                    <ng-container matColumnDef="eventTypeDisp" >
                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Payment Type</mat-header-cell>
                      <mat-cell   *matCellDef="let row">{{row.eventTypeDisp | titlecase}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="guarantee_start_day" >
                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Payment From</mat-header-cell>
                      <mat-cell    *matCellDef="let row">{{row.guarantee_start_day}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="guarantee_end_day" >
                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Payment To</mat-header-cell>
                      <mat-cell   *matCellDef="let row">{{row.guarantee_end_day}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="created" >
                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Payment Date</mat-header-cell>
                      <mat-cell   *matCellDef="let row">{{row.created}}</mat-cell>
                    </ng-container>
                    <ng-container  matColumnDef="voided_or_expired_date" >
                      <mat-header-cell  *matHeaderCellDef mat-sort-header  class="myHeader">Voided</mat-header-cell>
                      <mat-cell [className]="row.voided_or_expired_date_disp == 'Yes'? 'redColor' : 'greenColor'"  *matCellDef="let row">{{row.voided_or_expired_date_disp}}</mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="otherCol; sticky: true"></mat-header-row>
                    <mat-row  *matRowDef="let row; columns: otherCol;" style="min-height: 26px;"  ></mat-row>
                  </mat-table>
                </div>
              </mat-card>
            </td>
          </tr>
        </table>
      </mat-card>

      <mat-card  class="quickView" *ngIf="showQuickViewVoid" >
        <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
          <tr>
            <td style="width: 95%; ">
              <div class="maher5" (click)="myApp.showCharts()"></div>

              <mat-horizontal-stepper linear   labelPosition="bottom" #stepper2 class="stepper" style="text-align: center">
                <mat-step disabled="true"  [completed]="exists">
                  <ng-template matStepLabel>Select For Void</ng-template>
                  <div class="smallerFont">
                    Please check records you would like to void and click Proceed. </div>
                  <span *ngIf="ipadView" class="smallerFont" style="padding-left: 85%; color: #E61E00" (click)="returnToSearch()">Back To Search</span>

                  <div class="flex-item2" >
                    <mat-table #table23  [dataSource]="quickViewData4" multiTemplateDataRows matSort >
                      <ng-container matColumnDef="id" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Container</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{row.id}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="voided_or_expired_date_disp" >
                        <mat-header-cell  *matHeaderCellDef mat-sort-header  class="myHeader">Status</mat-header-cell>
                        <mat-cell   [className]="row.voided_or_expired_date_disp == 'Voided'? 'redColor' : 'greenColor'"  *matCellDef="let row">{{row.voided_or_expired_date_disp}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="sslDisp" >
                        <mat-header-cell  *matHeaderCellDef mat-sort-header  class="myHeader">Line Op</mat-header-cell>
                        <mat-cell  *matCellDef="let row">{{row.sslDisp}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="vesselVoyageDisp" >
                        <mat-header-cell  *matHeaderCellDef mat-sort-header  class="myHeader">Vessel/Voyage</mat-header-cell>
                        <mat-cell  *matCellDef="let row">{{row.vesselVoyageDisp}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="category_description" >
                        <mat-header-cell  *matHeaderCellDef mat-sort-header  class="myHeader">Category</mat-header-cell>
                        <mat-cell  *matCellDef="let row">{{row.category_description}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="event_type_description" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Type</mat-header-cell>
                        <mat-cell   *matCellDef="let row">{{row.event_type_description}}</mat-cell>
                      </ng-container>
                      <ng-container  matColumnDef="guarantee_start_day" >
                        <mat-header-cell  *matHeaderCellDef mat-sort-header  class="myHeader">From</mat-header-cell>
                        <mat-cell  *matCellDef="let row">{{row.guarantee_start_day}}</mat-cell>
                      </ng-container>
                      <ng-container  matColumnDef="guarantee_end_day" >
                        <mat-header-cell  *matHeaderCellDef mat-sort-header  class="myHeader">To</mat-header-cell>
                        <mat-cell   *matCellDef="let row">{{row.guarantee_end_day}}</mat-cell>
                      </ng-container>
                      <ng-container  matColumnDef="guarantee_amount" >
                        <mat-header-cell   *matHeaderCellDef mat-sort-header  class="myHeader">Total</mat-header-cell>
                        <mat-cell  *matCellDef="let row">{{row.guarantee_amount}}</mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="check2" >
                        <mat-header-cell  *matHeaderCellDef  matTooltip="click to check/uncheck all" class="myHeader" ><img (click)="checkAll('V')" style="vertical-align: center;height:26px; width: 26px" src="assets/check_circle_white.png" ></mat-header-cell>
                        <mat-cell *matCellDef="let row">
                          <mat-checkbox [hidden]="(row.voided_or_expired_date_disp=='Voided' || row.maherError!=null) || (row.category_description=='Export' && row.event_type_description=='Storage')" #mySel color="warn" (click)="$event.stopPropagation()"
                                        (change)="masterToggleVoid(row,selection3.isSelected(row)) ? selection3.toggle(row) : null"
                                        [checked]="selection3.isSelected(row)">
                          </mat-checkbox>
                        </mat-cell>
                      </ng-container>
                      <mat-header-row *matHeaderRowDef="voidCol; sticky: true"></mat-header-row>
                      <mat-row  *matRowDef="let row; columns: voidCol;" style="min-height: 26px;"  ></mat-row>
                    </mat-table>
                    <mat-toolbar style="width: 100%; display: unset">
                      <mat-toolbar-row style="width: 100%; ">
                        <mat-paginator class="myPaginator"  [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
                        <div style="padding-left: 18%">
                          <button mat-button matStepperNext (click)="voidButtonHit()" class="blueButton" >Void Selected</button>
                          <div class="errorDiv2 flash" *ngIf="nothingSelected && submitted">Must Select At Least One Record</div>
                        </div>
                      </mat-toolbar-row>
                    </mat-toolbar>
                  </div>
                </mat-step>


                <mat-step  disabled="true" [completed]="allDone">
                  <ng-template matStepLabel>Confirmation</ng-template>
                  <div >
                    <table style="width: 100%; min-height: 100%; padding-top: 10px">
                      <tr>
                        <td style="width: 90%;">
                          <table style="width: 100%">
                            <tr>
                              <td style="width: 60%;text-align: left">
                                <div class="titleFont" style="font-size: 23px">Void Confirmation</div>
                                <span *ngIf="ipadView" class="smallerFont" style=" color: #E61E00; text-align: right; padding-left: 63%" (click)="returnToSearch()">Back To Search</span>

                              </td>
                              <td style="width: 40%; text-align: right">
                                <div class="titleFont" style="padding-left: 3%; font-size: 23px">Date: <a style="color: green">{{today2 | date:'MM-dd-yyyy hh:mm'}}</a></div>
                              </td>
                            </tr>
                          </table>
                          <table style="width: 100%; min-height: 100%; padding: 0px; margin: 0px">
                            <tr>
                              <td style="width: 85%; height: 100%; text-align: center;" >
                                <table  class="table-fill" style="height: 100%">
                                  <tr>



                                    <td style="vertical-align: top;background-color: rgba(238,238,237,0.7); border: #E61E00 1px solid; height: 100%">

                                      <div >
                                        <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Voider Information</div>

                                        <div style="padding-top: 2px">
                                          <mat-form-field appearance="outline">
                                            <mat-label style="font-size: 16px; color: #E61E00">Steamship Line</mat-label>
                                            <input  [(ngModel)]="myUser.company_name"  matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                        <div>
                                          <mat-form-field appearance="outline" >
                                            <mat-label style="font-size: 16px; color: #E61E00">Address 1</mat-label>
                                            <input [(ngModel)]="myUser.address_1"  matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                        <div>
                                          <mat-form-field appearance="outline" >
                                            <mat-label style="font-size: 16px; color: #E61E00">Address 2</mat-label>
                                            <input [(ngModel)]="myUser.address_2"  matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                        <div>
                                          <mat-form-field appearance="outline" >
                                            <mat-label style="font-size: 16px; color: #E61E00">City</mat-label>
                                            <input [(ngModel)]="myUser.city"  matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                        <div>
                                          <mat-form-field appearance="outline" >
                                            <mat-label style="font-size: 16px; color: #E61E00">State/Region</mat-label>
                                            <input [(ngModel)]="myUser.state"  matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                        <div>
                                          <mat-form-field appearance="outline" >
                                            <mat-label style="font-size: 16px; color: #E61E00">Zip Code</mat-label>
                                            <input [(ngModel)]="myUser.zip"  matInput readonly/>
                                          </mat-form-field>
                                        </div>


                                      </div>
                                    </td>
                                    <td style="vertical-align: top" style="background-color:rgba(23,122,241,0.07); border: #E61E00 1px solid; height: 100%; " >

                                      <div>
                                        <img style="height: 246px;" src="assets/void.png" >

                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>



                        </td>
                      </tr>
                    </table>

                    <div class="flex-item6" style="padding-top: 5px; background-color: rgba(238,238,237,0.7); border: #E61E00 1px solid;" >
                      <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 5px ">Current Voids</div>
                      <mat-table #table23 [dataSource]="quickViewData5" multiTemplateDataRows matSort >
                        <ng-container matColumnDef="status" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Status</mat-header-cell>
                          <mat-cell  [className]="row.status.toUpperCase() == 'SUCCESSFUL' ? 'greenColor' : 'redColor'"  *matCellDef="let row">{{row.status}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="guarantee_id" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Confirmation #</mat-header-cell>
                          <mat-cell [className]="row.guarantee_id != null ? 'greenColor' : 'redColor'"  *matCellDef="let row">{{row.guarantee_id}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="id" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Container</mat-header-cell>
                          <mat-cell  *matCellDef="let row">{{row.id}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="event_type_description" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Charge Type</mat-header-cell>
                          <mat-cell  *matCellDef="let row">{{row.event_type_description}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="guarantee_start_day" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Payment From</mat-header-cell>
                          <mat-cell  *matCellDef="let row">{{row.guarantee_start_day}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="guarantee_end_day" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Payment To</mat-header-cell>
                          <mat-cell  *matCellDef="let row">{{row.guarantee_end_day}}</mat-cell>
                        </ng-container>
                        <ng-container  matColumnDef="totalAmountDisp" >
                          <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Amount</mat-header-cell>
                          <mat-cell  *matCellDef="let row">{{row.totalAmountDisp}}</mat-cell>
                        </ng-container>



                        <mat-header-row *matHeaderRowDef="voidConfirm; sticky: true"></mat-header-row>
                        <mat-row  *matRowDef="let row; columns: voidConfirm;" style="min-height: 26px;background-color: rgba(238,238,237,0.7);" class="topRow"  ></mat-row>

                      </mat-table>
                      <div style="width: 100%; text-align: right; padding-top: 10px">
                        <p  class="total">Total: {{grandTotalDisp}}</p>

                      </div>

                    </div>


                  </div>
                </mat-step>



              </mat-horizontal-stepper>
            </td>
          </tr>
        </table>
      </mat-card>
    </td>
    <td class="mainLowerTd">
      <mat-card id="badArea" class="speech-bubble" *ngIf="ipadAppear" id="noPrint">
        <div >
          <div class="payment" style="margin-top: 2%;"></div>
          <div class="titleFont" *ngIf="myUser.role=='LINEOP' && screenMode=='E'" style="padding-bottom: 10px; ">Container Charges Entry </div>
          <div class="titleFont" *ngIf="myUser.role=='LINEOP' && screenMode=='I'" style="padding-bottom: 10px; ">Container Charges Inquiry </div>
          <div class="titleFont" *ngIf="myUser.role=='LINEOP' && screenMode=='V'" style="padding-bottom: 10px; ">Container Void </div>
          <div class="titleFont" *ngIf="myUser.role!='LINEOP' && screenMode=='E'" style="padding-bottom: 10px; ">Container Charges Entry </div>
          <div class="titleFont" *ngIf="myUser.role!='LINEOP' && screenMode=='I'" style="padding-bottom: 10px; ">Container Charges Inquiry </div>
          <div class="titleFont" *ngIf="myUser.role!='LINEOP' && screenMode=='V'" style="padding-bottom: 10px; ">Container Void </div>


          <div style="padding-top: 5px" *ngIf="!inquiryOnly">
            <mat-button-toggle-group [(ngModel)]="screenMode" (click)="setCheckedField()">
              <mat-button-toggle checked class="beigeButton"  value="E">entry</mat-button-toggle>
              <mat-button-toggle class="beigeButton"  value="I" >inquiry</mat-button-toggle>
              <mat-button-toggle class="beigeButton" value="V">void</mat-button-toggle>
            </mat-button-toggle-group>
          </div>

          <div style="padding-top: 10px" *ngIf="screenMode=='E' &&  (myUser.role=='LINEOP' || myUser.credit_status=='OAC')">
            <mat-radio-group [(ngModel)]="payType" (click)="resetScreen()">
              <mat-radio-button class="smallerFont" style="font-weight: bolder" value="C" >Credit Card</mat-radio-button>
              <span style="padding-left: 5px"></span>
              <mat-radio-button class="smallerFont"  style="font-weight: bolder"  value="G" >Guarantee</mat-radio-button>
            </mat-radio-group>
          </div>


          <div class="flex-item3" style="padding-top: 10px">
            <div  class="lowerCaseLetters" style="font-size: 14px; text-align: center; padding-top: 5px">Enter Up To 100 Containers</div>
            <mat-form-field  appearance="outline" class="newField" >
              <textarea class="textarea" [(ngModel)]="txtFromArea"  matInput cdkTextareaAutosize oninput="this.value = this.value.toUpperCase()"></textarea>
            </mat-form-field>
          </div>
          <div style="text-align: center">
            <div class="errorDiv2"  style="text-align: center" *ngIf="submitted && didntEnterShit">Must Have 1 Container</div>
            <div class="errorDiv2"  style="text-align: center"*ngIf="submitted && badContainer">{{theError}}</div>
            <div class="errorDiv2" style="text-align: center" *ngIf="submitted && noPayType">Must Choose Payment Type</div>
            <div class="errorDiv2" style="text-align: center" *ngIf="submitted && badChars">Invalid Character in {{containerNum}}</div>

          </div>



        </div>





        <mat-toolbar mat-toolbar class="toolbar2">
          <mat-toolbar-row style="justify-content: center">
            <button mat-raised-button (click)="getSearchItems()"   class="blueButton" >Search</button>
            <span class="example-fill-remaining-space3"></span>

            <button mat-raised-button   class="redButton" (click)="wipeOutSearch()" >Clear List</button>

          </mat-toolbar-row>
        </mat-toolbar>




        <div>
          <mat-form-field class="myOption2"  appearance="outline">
            <mat-label>Saved Lists</mat-label>
            <mat-select  [(value)]="savedList" >
              <mat-option style="font-weight: bold"  *ngFor="let lr of savedLists" [value]="lr.id">{{lr.description}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-toolbar class="myToolbar" >
          <mat-toolbar-row style="padding-left: 14%; height: 35px" >
            <button mat-button matTooltip="retrieve your saved list" (click)="showContainersFromList()" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/saved_search-24px.svg" ></button>
            <button mat-button matTooltip="update your saved list" (click)="updateContainerList('U')" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/save-24px.svg" ></button>
            <button mat-button matTooltip="delete your saved list" (click)="deleteHit()" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/delete-24px.svg" ></button>
          </mat-toolbar-row>
        </mat-toolbar>
        <mat-toolbar class="myToolbar" style="background-color: white">
          <mat-toolbar-row style="width: 81%">
            <mat-form-field  appearance="outline" >
              <mat-label>New List</mat-label>
              <input maxlength="15" [(ngModel)]="myNewListName"  oninput="this.value = this.value.toUpperCase()" matInput/>
            </mat-form-field>
            <button mat-button matTooltip="create a new saved list" (click)="updateContainerList('I')" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/save-24px.svg" ></button>
          </mat-toolbar-row>
          <mat-toolbar-row style="height: 26px; justify-content: center">
            <div class="errorDiv2" style="text-align: center" *ngIf="submitted && insertListExists">List Exists For This User</div>
            <div class="errorDiv2" style="text-align: center" *ngIf="submitted && insertNoConts ">List Needs At Least 1 Container</div>
            <div class="errorDiv2" style="text-align: center" *ngIf="submitted && noListName ">List Name Cannot Be Blank</div>
          </mat-toolbar-row>
        </mat-toolbar>

      </mat-card>

    </td>
  </tr>
</table>






